import { useState, useEffect, useRef } from "react";
import axios from "axios";
import Menubar from "../Menubar/Menubar";
import { Outlet, useNavigate } from "react-router-dom";
import "../Dashboard/Dashboard.css";
import { Tooltip } from "antd";
import { MdKeyboardDoubleArrowLeft } from "react-icons/md";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import { FaEdit, FaEye } from "react-icons/fa";
import { MdCancel } from "react-icons/md";
import { MdDelete } from "react-icons/md";
import { confirmAlert } from "react-confirm-alert";
import { toast } from "react-toastify";
import { FaTrash } from "react-icons/fa";
import { RiFileEditFill } from "react-icons/ri";
import { FaFileArrowDown } from "react-icons/fa6";
import { MdHolidayVillage } from "react-icons/md";
import { FaHotel } from "react-icons/fa6";
import { VscPercentage } from "react-icons/vsc";
import { FaWandMagicSparkles } from "react-icons/fa6";
import { FaStar } from "react-icons/fa";
const ProgressBar = ({ value }) => {
  const getColor = () => {
    if (value <= 50) return "bg-red-500";
    if (value < 100) return "bg-yellow-300";
    return "bg-green-500";
  };
  const getTextColor = () => {
    if (value <= 50) return "text-red-500";
    if (value < 100) return "text-yellow-400";
    return "text-green-500";
  };

  return (
    <div className="flex flex-col items-center">
      {/* percentage text */}
      <div className={`text-sm font-semibold mb-1 ${getTextColor()}`}>
        {value}%
      </div>

      {/* smaller progress bar */}
      <div className="w-20 bg-gray-200 h-2 rounded">
        <div
          className={`h-2 rounded ${getColor()} transition-all duration-500`}
          style={{ width: `${value}%` }}
        />
      </div>
    </div>
  );
};
const StarRating = ({ rating = 0, onRate }) => {
  const [hover, setHover] = useState(0);

  return (
    <div className="flex gap-0.5">
      {[1, 2, 3, 4, 5].map((star) => (
        <button
          key={star}
          type="button"
          onClick={() => onRate(star)}
          onMouseEnter={() => setHover(star)}
          onMouseLeave={() => setHover(0)}
          className="focus:outline-none transition-transform hover:scale-110"
        >
          <FaStar
            size={16}
            className={
              (hover || rating) >= star ? "text-yellow-400" : "text-gray-300"
            }
          />
        </button>
      ))}
    </div>
  );
};
const Properties = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
  // const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 1024);
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
    const savedState = localStorage.getItem("menubarOpen");

    if (savedState !== null) {
      return JSON.parse(savedState);
    }

    return window.innerWidth >= 1024;
  });
  const [searchQuery, setSearchQuery] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [table_property_villa, setTableProperty_villa] = useState([]);
  const [table_property_hotel, setTableProperty_hotel] = useState([]);
  const [table_property_resort, setTableProperty_resort] = useState([]);
  const [table_property_apartment, setTableProperty_apartment] = useState([]);
  const [villaProgress, setVillaProgress] = useState({});
  const [hotelProgress, setHotelProgress] = useState({});
  // const value = villa.progress;
  // const value = 50;
  // Villa pagination
  // const rowsPerPage_villa = 20;
  // const [currentPage_villa, setCurrentPage_villa] = useState(1);
  // const filtered_property_villa = table_property_villa.filter((villa) =>
  //   [villa.customer, villa.propertyowner, villa.location].some((field) =>
  //     field?.toLowerCase().includes(searchQuery.toLowerCase())
  //   )
  // );
  // const indexOfLastTable_villa = currentPage_villa * rowsPerPage_villa;
  // const indexOfFirstTable_villa = indexOfLastTable_villa - rowsPerPage_villa;

  // const current_property_villa = filtered_property_villa.slice(
  //   indexOfFirstTable_villa,
  //   indexOfLastTable_villa
  // );

  // const totalPages_villa = Math.ceil(
  //   filtered_property_villa.length / rowsPerPage_villa
  // );

  // const handlePageChange_villa = (pageNumber) => {
  //   setCurrentPage_villa(pageNumber);
  // };

  // const handleNextPage_villa = () => {
  //   if (currentPage_villa < totalPages_villa) {
  //     setCurrentPage_villa(currentPage_villa + 1);
  //   }
  // };

  // const handlePrevPage_villa = () => {
  //   if (currentPage_villa > 1) {
  //     setCurrentPage_villa(currentPage_villa - 1);
  //   }
  // };

  // const generatePageNumbers_villa = () => {
  //   const pages = [];
  //   if (totalPages_villa <= 3) {
  //     for (let i = 1; i <= totalPages_villa; i++) pages.push(i);
  //   } else {
  //     if (currentPage_villa > 2) {
  //       pages.push(1, "...");
  //     }
  //     for (let i = currentPage_villa - 1; i <= currentPage_villa + 1; i++) {
  //       if (i > 0 && i <= totalPages_villa) pages.push(i);
  //     }
  //     if (currentPage_villa < totalPages_villa - 1) {
  //       pages.push("...", totalPages_villa);
  //     }
  //   }
  //   return pages;
  // };
  // Villa pagination
  const rowsPerPage_villa = 20;
  // const [currentPage_villa, setCurrentPage_villa] = useState(1);
  const [currentPage_villa, setCurrentPage_villa] = useState(() => {
    const saved = sessionStorage.getItem("villaPage");
    return saved ? parseInt(saved, 10) : 1;
  });

  // Filter properties based on search query
  // const filtered_property_villa = table_property_villa.filter((villa) =>
  //   [villa.customer, villa.propertyowner, villa.location].some((field) =>
  //     field?.toLowerCase().includes(searchQuery.toLowerCase()),
  //   ),
  // );
  const filtered_property_villa = table_property_villa.filter((villa) => {
    const query = searchQuery.toLowerCase();

    const progress = villaProgress[villa.order]?.toString() || "";

    return [villa.customer, villa.propertyowner, villa.location, progress].some(
      (field) => field?.toLowerCase().includes(query),
    );
  });
  // Apply custom sorting
  const sorted_property_villa = [...filtered_property_villa].sort((a, b) => {
    const aIsToggled = a.topPropertyEnabled || a.topFiveEnabled;
    const bIsToggled = b.topPropertyEnabled || b.topFiveEnabled;

    if (aIsToggled === bIsToggled) {
      return b.order - a.order;
    }

    return aIsToggled && !bIsToggled ? -1 : 1;
  });

  // Apply pagination
  const indexOfLastTable_villa = currentPage_villa * rowsPerPage_villa;
  const indexOfFirstTable_villa = indexOfLastTable_villa - rowsPerPage_villa;

  const current_property_villa = sorted_property_villa.slice(
    indexOfFirstTable_villa,
    indexOfLastTable_villa,
  );

  const totalPages_villa = Math.ceil(
    sorted_property_villa.length / rowsPerPage_villa,
  );

  // The rest of your pagination functions remain unchanged
  const handlePageChange_villa = (pageNumber) => {
    setCurrentPage_villa(pageNumber);
  };

  const handleNextPage_villa = () => {
    if (currentPage_villa < totalPages_villa) {
      setCurrentPage_villa(currentPage_villa + 1);
    }
  };

  const handlePrevPage_villa = () => {
    if (currentPage_villa > 1) {
      setCurrentPage_villa(currentPage_villa - 1);
    }
  };

  const generatePageNumbers_villa = () => {
    const pages = [];
    if (totalPages_villa <= 3) {
      for (let i = 1; i <= totalPages_villa; i++) pages.push(i);
    } else {
      if (currentPage_villa > 2) {
        pages.push(1, "...");
      }
      for (let i = currentPage_villa - 1; i <= currentPage_villa + 1; i++) {
        if (i > 0 && i <= totalPages_villa) pages.push(i);
      }
      if (currentPage_villa < totalPages_villa - 1) {
        pages.push("...", totalPages_villa);
      }
    }
    return pages;
  };

  // ---------------- Hotels ----------------
  // const rowsPerPage_hotel = 20;
  // const [currentPage_hotel, setCurrentPage_hotel] = useState(1);

  // const filtered_property_hotel = table_property_hotel.filter((hotel) =>
  //   [hotel.customer, hotel.propertyowner, hotel.location].some((field) =>
  //     field?.toLowerCase().includes(searchQuery.toLowerCase())
  //   )
  // );
  // const indexOfLastTable_hotel = currentPage_hotel * rowsPerPage_hotel;
  // const indexOfFirstTable_hotel = indexOfLastTable_hotel - rowsPerPage_hotel;
  // const current_property_hotel = filtered_property_hotel.slice(
  //   indexOfFirstTable_hotel,
  //   indexOfLastTable_hotel
  // );
  // const totalPages_hotel = Math.ceil(
  //   filtered_property_hotel.length / rowsPerPage_hotel
  // );

  // const handlePageChange_hotel = (pageNumber) =>
  //   setCurrentPage_hotel(pageNumber);
  // const handleNextPage_hotel = () => {
  //   if (currentPage_hotel < totalPages_hotel)
  //     setCurrentPage_hotel((p) => p + 1);
  // };
  // const handlePrevPage_hotel = () => {
  //   if (currentPage_hotel > 1) setCurrentPage_hotel((p) => p - 1);
  // };
  // const generatePageNumbers_hotel = () => {
  //   const pageNumbers = [];
  //   if (totalPages_hotel <= 3) {
  //     for (let i = 1; i <= totalPages_hotel; i++) pageNumbers.push(i);
  //   } else {
  //     if (currentPage_hotel > 2) {
  //       pageNumbers.push(1);
  //       pageNumbers.push("...");
  //     }
  //     for (let i = currentPage_hotel - 1; i <= currentPage_hotel + 1; i++) {
  //       if (i > 0 && i <= totalPages_hotel) pageNumbers.push(i);
  //     }
  //     if (currentPage_hotel < totalPages_hotel - 1) {
  //       pageNumbers.push("...");
  //       pageNumbers.push(totalPages_hotel);
  //     }
  //   }
  //   return pageNumbers;
  // };
  const rowsPerPage_hotel = 20;
  const [currentPage_hotel, setCurrentPage_hotel] = useState(1);
  const filtered_property_hotel = table_property_hotel.filter((hotel) => {
    const query = searchQuery.toLowerCase();

    const progress = hotelProgress[hotel.order]?.toString() || "";

    return [hotel.customer, hotel.propertyowner, hotel.location, progress].some(
      (field) => field?.toLowerCase().includes(query),
    );
  });
  // const filtered_property_hotel = table_property_hotel.filter((hotel) =>
  //   [hotel.customer, hotel.propertyowner, hotel.location].some((field) =>
  //     field?.toLowerCase().includes(searchQuery.toLowerCase()),
  //   ),
  // );

  // Apply custom sorting for hotels
  const sorted_property_hotel = [...filtered_property_hotel].sort((a, b) => {
    const aIsToggled = a.topPropertyEnabled || a.topFiveEnabled;
    const bIsToggled = b.topPropertyEnabled || b.topFiveEnabled;

    if (aIsToggled === bIsToggled) {
      return b.order - a.order;
    }

    return aIsToggled && !bIsToggled ? -1 : 1;
  });

  const indexOfLastTable_hotel = currentPage_hotel * rowsPerPage_hotel;
  const indexOfFirstTable_hotel = indexOfLastTable_hotel - rowsPerPage_hotel;
  const current_property_hotel = sorted_property_hotel.slice(
    indexOfFirstTable_hotel,
    indexOfLastTable_hotel,
  );
  const totalPages_hotel = Math.ceil(
    sorted_property_hotel.length / rowsPerPage_hotel,
  );

  const handlePageChange_hotel = (pageNumber) =>
    setCurrentPage_hotel(pageNumber);
  const handleNextPage_hotel = () => {
    if (currentPage_hotel < totalPages_hotel)
      setCurrentPage_hotel((p) => p + 1);
  };
  const handlePrevPage_hotel = () => {
    if (currentPage_hotel > 1) setCurrentPage_hotel((p) => p - 1);
  };
  const generatePageNumbers_hotel = () => {
    const pageNumbers = [];
    if (totalPages_hotel <= 3) {
      for (let i = 1; i <= totalPages_hotel; i++) pageNumbers.push(i);
    } else {
      if (currentPage_hotel > 2) {
        pageNumbers.push(1);
        pageNumbers.push("...");
      }
      for (let i = currentPage_hotel - 1; i <= currentPage_hotel + 1; i++) {
        if (i > 0 && i <= totalPages_hotel) pageNumbers.push(i);
      }
      if (currentPage_hotel < totalPages_hotel - 1) {
        pageNumbers.push("...");
        pageNumbers.push(totalPages_hotel);
      }
    }
    return pageNumbers;
  };

  // ---------------- Resorts ----------------
  // const rowsPerPage_resort = 20;
  // const [currentPage_resort, setCurrentPage_resort] = useState(1);

  // const filtered_property_resort = table_property_resort.filter((resort) =>
  //   [resort.customer, resort.propertyowner, resort.location].some((field) =>
  //     field?.toLowerCase().includes(searchQuery.toLowerCase())
  //   )
  // );
  // const indexOfLastTable_resort = currentPage_resort * rowsPerPage_resort;
  // const indexOfFirstTable_resort = indexOfLastTable_resort - rowsPerPage_resort;
  // const current_property_resort = filtered_property_resort.slice(
  //   indexOfFirstTable_resort,
  //   indexOfLastTable_resort
  // );
  // const totalPages_resort = Math.ceil(
  //   filtered_property_resort.length / rowsPerPage_resort
  // );

  // const handlePageChange_resort = (pageNumber) =>
  //   setCurrentPage_resort(pageNumber);
  // const handleNextPage_resort = () => {
  //   if (currentPage_resort < totalPages_resort)
  //     setCurrentPage_resort((p) => p + 1);
  // };
  // const handlePrevPage_resort = () => {
  //   if (currentPage_resort > 1) setCurrentPage_resort((p) => p - 1);
  // };
  // const generatePageNumbers_resort = () => {
  //   const pageNumbers = [];
  //   if (totalPages_resort <= 3) {
  //     for (let i = 1; i <= totalPages_resort; i++) pageNumbers.push(i);
  //   } else {
  //     if (currentPage_resort > 2) {
  //       pageNumbers.push(1);
  //       pageNumbers.push("...");
  //     }
  //     for (let i = currentPage_resort - 1; i <= currentPage_resort + 1; i++) {
  //       if (i > 0 && i <= totalPages_resort) pageNumbers.push(i);
  //     }
  //     if (currentPage_resort < totalPages_resort - 1) {
  //       pageNumbers.push("...");
  //       pageNumbers.push(totalPages_resort);
  //     }
  //   }
  //   return pageNumbers;
  // };
  const rowsPerPage_resort = 20;
  const [currentPage_resort, setCurrentPage_resort] = useState(1);

  const filtered_property_resort = table_property_resort.filter((resort) =>
    [resort.customer, resort.propertyowner, resort.location].some((field) =>
      field?.toLowerCase().includes(searchQuery.toLowerCase()),
    ),
  );

  // Apply custom sorting for resorts
  const sorted_property_resort = [...filtered_property_resort].sort((a, b) => {
    const aIsToggled = a.topPropertyEnabled || a.topFiveEnabled;
    const bIsToggled = b.topPropertyEnabled || b.topFiveEnabled;

    if (aIsToggled === bIsToggled) {
      return b.order - a.order;
    }

    return aIsToggled && !bIsToggled ? -1 : 1;
  });

  const indexOfLastTable_resort = currentPage_resort * rowsPerPage_resort;
  const indexOfFirstTable_resort = indexOfLastTable_resort - rowsPerPage_resort;
  const current_property_resort = sorted_property_resort.slice(
    indexOfFirstTable_resort,
    indexOfLastTable_resort,
  );
  const totalPages_resort = Math.ceil(
    sorted_property_resort.length / rowsPerPage_resort,
  );

  const handlePageChange_resort = (pageNumber) =>
    setCurrentPage_resort(pageNumber);
  const handleNextPage_resort = () => {
    if (currentPage_resort < totalPages_resort)
      setCurrentPage_resort((p) => p + 1);
  };
  const handlePrevPage_resort = () => {
    if (currentPage_resort > 1) setCurrentPage_resort((p) => p - 1);
  };
  const generatePageNumbers_resort = () => {
    const pageNumbers = [];
    if (totalPages_resort <= 3) {
      for (let i = 1; i <= totalPages_resort; i++) pageNumbers.push(i);
    } else {
      if (currentPage_resort > 2) {
        pageNumbers.push(1);
        pageNumbers.push("...");
      }
      for (let i = currentPage_resort - 1; i <= currentPage_resort + 1; i++) {
        if (i > 0 && i <= totalPages_resort) pageNumbers.push(i);
      }
      if (currentPage_resort < totalPages_resort - 1) {
        pageNumbers.push("...");
        pageNumbers.push(totalPages_resort);
      }
    }
    return pageNumbers;
  };
  // ---------------- Apartments ----------------
  // const rowsPerPage_apartment = 20;
  // const [currentPage_apartment, setCurrentPage_apartment] = useState(1);

  // const filtered_property_apartment = table_property_apartment.filter(
  //   (apartment) =>
  //     [apartment.customer, apartment.propertyowner, apartment.location].some(
  //       (field) => field?.toLowerCase().includes(searchQuery.toLowerCase())
  //     )
  // );
  // const indexOfLastTable_apartment =
  //   currentPage_apartment * rowsPerPage_apartment;
  // const indexOfFirstTable_apartment =
  //   indexOfLastTable_apartment - rowsPerPage_apartment;
  // const current_property_apartment = filtered_property_apartment.slice(
  //   indexOfFirstTable_apartment,
  //   indexOfLastTable_apartment
  // );
  // const totalPages_apartment = Math.ceil(
  //   filtered_property_apartment.length / rowsPerPage_apartment
  // );

  // const handlePageChange_apartment = (pageNumber) =>
  //   setCurrentPage_apartment(pageNumber);
  // const handleNextPage_apartment = () => {
  //   if (currentPage_apartment < totalPages_apartment)
  //     setCurrentPage_apartment((p) => p + 1);
  // };
  // const handlePrevPage_apartment = () => {
  //   if (currentPage_apartment > 1) setCurrentPage_apartment((p) => p - 1);
  // };
  // const generatePageNumbers_apartment = () => {
  //   const pageNumbers = [];
  //   if (totalPages_apartment <= 3) {
  //     for (let i = 1; i <= totalPages_apartment; i++) pageNumbers.push(i);
  //   } else {
  //     if (currentPage_apartment > 2) {
  //       pageNumbers.push(1);
  //       pageNumbers.push("...");
  //     }
  //     for (
  //       let i = currentPage_apartment - 1;
  //       i <= currentPage_apartment + 1;
  //       i++
  //     ) {
  //       if (i > 0 && i <= totalPages_apartment) pageNumbers.push(i);
  //     }
  //     if (currentPage_apartment < totalPages_apartment - 1) {
  //       pageNumbers.push("...");
  //       pageNumbers.push(totalPages_apartment);
  //     }
  //   }
  //   return pageNumbers;
  // };
  const rowsPerPage_apartment = 20;
  const [currentPage_apartment, setCurrentPage_apartment] = useState(1);

  const filtered_property_apartment = table_property_apartment.filter(
    (apartment) =>
      [apartment.customer, apartment.propertyowner, apartment.location].some(
        (field) => field?.toLowerCase().includes(searchQuery.toLowerCase()),
      ),
  );

  // Apply custom sorting for apartments
  const sorted_property_apartment = [...filtered_property_apartment].sort(
    (a, b) => {
      const aIsToggled = a.topPropertyEnabled || a.topFiveEnabled;
      const bIsToggled = b.topPropertyEnabled || b.topFiveEnabled;

      if (aIsToggled === bIsToggled) {
        return b.order - a.order;
      }

      return aIsToggled && !bIsToggled ? -1 : 1;
    },
  );

  const indexOfLastTable_apartment =
    currentPage_apartment * rowsPerPage_apartment;
  const indexOfFirstTable_apartment =
    indexOfLastTable_apartment - rowsPerPage_apartment;
  const current_property_apartment = sorted_property_apartment.slice(
    indexOfFirstTable_apartment,
    indexOfLastTable_apartment,
  );
  const totalPages_apartment = Math.ceil(
    sorted_property_apartment.length / rowsPerPage_apartment,
  );

  const handlePageChange_apartment = (pageNumber) =>
    setCurrentPage_apartment(pageNumber);
  const handleNextPage_apartment = () => {
    if (currentPage_apartment < totalPages_apartment)
      setCurrentPage_apartment((p) => p + 1);
  };
  const handlePrevPage_apartment = () => {
    if (currentPage_apartment > 1) setCurrentPage_apartment((p) => p - 1);
  };
  const generatePageNumbers_apartment = () => {
    const pageNumbers = [];
    if (totalPages_apartment <= 3) {
      for (let i = 1; i <= totalPages_apartment; i++) pageNumbers.push(i);
    } else {
      if (currentPage_apartment > 2) {
        pageNumbers.push(1);
        pageNumbers.push("...");
      }
      for (
        let i = currentPage_apartment - 1;
        i <= currentPage_apartment + 1;
        i++
      ) {
        if (i > 0 && i <= totalPages_apartment) pageNumbers.push(i);
      }
      if (currentPage_apartment < totalPages_apartment - 1) {
        pageNumbers.push("...");
        pageNumbers.push(totalPages_apartment);
      }
    }
    return pageNumbers;
  };
  useEffect(() => {
    const fetchAllProgress = async () => {
      try {
        const res = await fetch(
          "https://demo.zorbastays.com/web-backend/property-completion-all",
        );

        const data = await res.json();

        // data format: {1: 72.6, 2: 80.4, 3: 69.4}

        setVillaProgress(data);
        setHotelProgress(data);
      } catch (err) {
        console.error("Failed to fetch progress:", err);
      }
    };

    fetchAllProgress();
  }, []);
  // useEffect(() => {
  //   if (!current_property_villa || current_property_villa.length === 0) return;

  //   const fetchAllProgress = async () => {
  //     const results = {};
  //     await Promise.all(
  //       current_property_villa.map(async (villa) => {
  //         try {
  //           const res = await fetch(
  //             `https://demo.zorbastays.com/web-backend/property-completion/${villa.order}`, // ✅ was villa.id
  //           );
  //           const data = await res.json();
  //           results[villa.order] = data.completionPct ?? 0; // ✅ was villa.id
  //         } catch {
  //           results[villa.order] = 0; // ✅ was villa.id
  //         }
  //       }),
  //     );
  //     setVillaProgress(results);
  //   };

  //   fetchAllProgress();
  // }, [current_property_villa]);
  // useEffect(() => {
  //   if (!current_property_hotel || current_property_hotel.length === 0) return;

  //   const fetchAllProgress = async () => {
  //     const results = {};
  //     await Promise.all(
  //       current_property_hotel.map(async (hotel) => {
  //         try {
  //           const res = await fetch(
  //             `https://demo.zorbastays.com/web-backend/property-completion/${hotel.order}`,
  //           );
  //           const data = await res.json();
  //           results[hotel.order] = data.completionPct ?? 0;
  //         } catch {
  //           results[hotel.order] = 0;
  //         }
  //       }),
  //     );
  //     setHotelProgress(results);
  //   };

  //   fetchAllProgress();
  // }, [current_property_hotel]);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 1024;
      setIsMobile(mobile);

      if (mobile) {
        setIsSidebarOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const navigate = useNavigate();

  const statusColors = {
    CANCELLED: "bg-amber-800/20 text-amber-800",
    CONFIRMED: "bg-green-500/20 text-green-500",
    BOOKED: "bg-purple-500/20 text-purple-500",
    FAILED: "bg-red-500/20 text-red-500",
    PENDING: "bg-yellow-200/40 text-yellow-300",
    PAID: "bg-transparent text-green-500",
    UNPAID: "bg-transparent text-red-400",
  };

  const [isOpen_popupForm, setIsOpen_popupForm] = useState(false);

  const [, setShowPopup_filter] = useState(false); //showPopup_filter
  const filterRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        setShowPopup_filter(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const [active, setActive] = useState("Villas");

  // const options = ["Villas", "Hotels", "Resorts", "Apartments"];
  const options = ["Villas", "Hotels"];

  const [selectedRows_apartment, setSelectedRows_apartment] = useState([]);

  const [selectedRows_villa, setSelectedRows_villa] = useState([]);

  const handleRowCheckboxChange_villa = (order) => {
    setSelectedRows_villa((prevSelected) =>
      prevSelected.includes(order)
        ? prevSelected.filter((id) => id !== order)
        : [...prevSelected, order],
    );
  };

  const handleSelectAll_villa = () => {
    if (selectedRows_villa.length === current_property_villa.length) {
      setSelectedRows_villa([]);
    } else {
      setSelectedRows_villa(
        current_property_villa.map((booking) => booking.order),
      );
    }
  };
  const handleSelectAll_apartment = (e) => {
    if (e.target.checked) {
      setSelectedRows_apartment(current_property_apartment.map((p) => p.id));
    } else {
      setSelectedRows_apartment([]);
    }
  };

  const handleToggle_topProperty_villa = async (order) => {
    const villa = table_property_villa.find((item) => item.order === order);
    const newEnabled = !villa.topPropertyEnabled;

    if (!newEnabled) {
      // turning OFF → clear in DB
      try {
        const res = await axios.post(
          "https://demo.zorbastays.com/web-backend/update-rank",
          {
            propertyid: order,
            propertytype: "villa",
            rank: 0,
          },
        );

        if (res.data.success) {
          const updated = table_property_villa.map((item) =>
            item.order === order
              ? { ...item, topPropertyEnabled: false, topPropertyValue: "" }
              : item,
          );
          setTableProperty_villa(updated);
          await refreshVillaRanks();
        } else {
          alert(res.data.message);
        }
      } catch (err) {
        console.error("Failed to reset top property", err);
        alert("Error updating top property toggle");
      }
    } else {
      // turning ON → just enable, don’t update DB yet
      const updated = table_property_villa.map((item) =>
        item.order === order
          ? { ...item, topPropertyEnabled: true, topPropertyValue: "" }
          : item,
      );
      setTableProperty_villa(updated);
    }
  };

  // const handleDropdownChange_topProperty_villa = (order, value) => {
  //   const updated = table_property_villa.map((item) =>
  //     item.order === order ? { ...item, topPropertyValue: value } : item
  //   );
  //   setTableProperty_villa(updated);
  // };
  const refreshVillaRanks = async () => {
    try {
      const res = await axios.get(
        "https://demo.zorbastays.com/web-backend/getTakenTopProperty?propertytype=villa",
      );
      if (res.data.success) {
        const allRanks = [1, 2, 3, 4, 5];
        const taken = res.data.taken || [];
        const available = allRanks.filter((r) => !taken.includes(r));
        setAvailableVillaRanks(available);
      }
    } catch (err) {
      console.error("Failed to refresh villa ranks", err);
    }
  };
  // Refresh Hotel ranks
  const refreshHotelRanks = async () => {
    try {
      const res = await axios.get(
        "https://demo.zorbastays.com/web-backend/getTakenTopProperty?propertytype=hotel",
      );
      if (res.data.success) {
        const allRanks = [1, 2, 3, 4, 5];
        const taken = res.data.taken || [];
        const available = allRanks.filter((r) => !taken.includes(r));
        setAvailableHotelRanks(available);
      }
    } catch (err) {
      console.error("Failed to refresh hotel ranks", err);
    }
  };

  // Refresh Resort ranks
  const refreshResortRanks = async () => {
    try {
      const res = await axios.get(
        "https://demo.zorbastays.com/web-backend/getTakenTopProperty?propertytype=resort",
      );
      if (res.data.success) {
        const allRanks = [1, 2, 3, 4, 5];
        const taken = res.data.taken || [];
        const available = allRanks.filter((r) => !taken.includes(r));
        setAvailableResortRanks(available);
      }
    } catch (err) {
      console.error("Failed to refresh resort ranks", err);
    }
  };

  const handleDropdownChange_topProperty_villa = async (order, value) => {
    try {
      const res = await axios.post(
        "https://demo.zorbastays.com/web-backend/update-rank",
        {
          propertyid: order,
          propertytype: "villa",
          rank: value,
        },
      );

      if (res.data.success) {
        const updated = table_property_villa.map((item) =>
          item.order === order ? { ...item, topPropertyValue: value } : item,
        );

        setTableProperty_villa(updated);
        await fetchProperties(); // 🔄 refresh data instead of reloading page
        await refreshVillaRanks();
      } else {
        alert(res.data.message); // e.g. "Rank 1 is already taken"
      }
    } catch (err) {
      console.error("Failed to update rank", err);
      alert("Error updating rank");
    }
  };

  const [selectedRows_hotel, setSelectedRows_hotel] = useState([]);

  const handleRowCheckboxChange_hotel = (order) => {
    setSelectedRows_hotel((prevSelected) =>
      prevSelected.includes(order)
        ? prevSelected.filter((id) => id !== order)
        : [...prevSelected, order],
    );
  };

  const handleSelectAll_hotel = () => {
    if (selectedRows_hotel.length === current_property_hotel.length) {
      setSelectedRows_hotel([]);
    } else {
      setSelectedRows_hotel(
        current_property_hotel.map((booking) => booking.order),
      );
    }
  };

  const handleToggle_topProperty_hotel = async (order) => {
    const hotel = table_property_hotel.find((item) => item.order === order);
    const newEnabled = !hotel.topPropertyEnabled;

    if (!newEnabled) {
      // Turning OFF → clear in DB
      try {
        const res = await axios.post(
          "https://demo.zorbastays.com/web-backend/update-rank",
          {
            propertyid: order,
            propertytype: "hotel",
            rank: 0,
          },
        );

        if (res.data.success) {
          const updated = table_property_hotel.map((item) =>
            item.order === order
              ? { ...item, topPropertyEnabled: false, topPropertyValue: "" }
              : item,
          );
          setTableProperty_hotel(updated);
          await refreshHotelRanks();
        } else {
          alert(res.data.message);
        }
      } catch (err) {
        console.error("Failed to reset top property (hotel)", err);
        alert("Error updating top property toggle");
      }
    } else {
      // Turning ON → just enable, wait for dropdown
      const updated = table_property_hotel.map((item) =>
        item.order === order
          ? { ...item, topPropertyEnabled: true, topPropertyValue: "" }
          : item,
      );
      setTableProperty_hotel(updated);
    }
  };

  const handleDropdownChange_topProperty_hotel = async (order, value) => {
    // const hotel = table_property_hotel.find((item) => item.order === order);

    try {
      const res = await axios.post(
        "https://demo.zorbastays.com/web-backend/update-rank",
        {
          propertyid: order,
          propertytype: "hotel",
          rank: parseInt(value, 10), // ensure number
        },
      );

      if (res.data.success) {
        const updated = table_property_hotel.map((item) =>
          item.order === order ? { ...item, topPropertyValue: value } : item,
        );
        setTableProperty_hotel(updated);
        await fetchProperties(); // refresh Hotels table
        await refreshHotelRanks();
      } else {
        alert(res.data.message);
      }
    } catch (err) {
      console.error("Failed to update hotel rank", err);
      alert("Error updating hotel rank");
    }
  };

  // const [table_property_resort, setTableProperty_resort] = useState([]);
  const fetchProperties = async (type) => {
    setIsLoading(true);
    try {
      const res = await axios.get(
        `https://demo.zorbastays.com/web-backend/type/${type.toLowerCase()}`,
      );
      const data = res.data.map((item) => ({
        order: item.id,
        customer: item.propertyname,
        productName: item.description,
        location: item.location,
        payment: item.currentprice,
        status: "CONFIRMED",
        topPropertyEnabled: item.istopproperty > 0,
        topPropertyValue: item.istopproperty || "",
        topFiveEnabled: item.istopfiverank > 0,
        topFiveValue: item.istopfiverank || "",
        propertyowner: item.propertyowner,
        availability: item.availability,
        rating: item.rating ?? null,
      }));

      if (type === "villa") setTableProperty_villa(data);
      if (type === "hotel") setTableProperty_hotel(data);
      if (type === "resort") setTableProperty_resort(data);
      if (type === "apartment") setTableProperty_apartment(data);
    } catch (err) {
      console.error("Failed to fetch properties", err);
    } finally {
      setIsLoading(false);
    }
  };
  // const fetchProperties = async (type) => {
  //   try {
  //     const res = await axios.get(
  //       `https://demo.zorbastays.com/web-backend/type/${type.toLowerCase()}`,
  //     );
  //     const data = res.data.map((item) => ({
  //       order: item.id,
  //       customer: item.propertyname,
  //       productName: item.description,
  //       location: item.location,
  //       payment: item.currentprice,
  //       status: "CONFIRMED",
  //       topPropertyEnabled: item.istopproperty > 0,
  //       topPropertyValue: item.istopproperty || "",
  //       topFiveEnabled: item.istopfiverank > 0,
  //       topFiveValue: item.istopfiverank || "",
  //       propertyowner: item.propertyowner,
  //       availability: item.availability,
  //       rating: item.rating ?? null,
  //     }));

  //     if (type === "villa") setTableProperty_villa(data);
  //     if (type === "hotel") setTableProperty_hotel(data);
  //     if (type === "resort") setTableProperty_resort(data);
  //     if (type === "apartment") setTableProperty_apartment(data);
  //   } catch (err) {
  //     console.error("Failed to fetch properties", err);
  //   }
  // };
  // useEffect(() => {
  //   if (active === "Villas") setCurrentPage_villa(1);
  //   if (active === "Hotels") setCurrentPage_hotel(1);
  //   if (active === "Resorts") setCurrentPage_resort(1);
  //   if (active === "Apartments") setCurrentPage_apartment(1);
  // }, [searchQuery, active]);

  const isFirstMount = useRef(true);

  useEffect(() => {
    if (isFirstMount.current) {
      isFirstMount.current = false;
      if (active === "Villas") fetchProperties("villa");
      if (active === "Hotels") fetchProperties("hotel");
      if (active === "Resorts") fetchProperties("resort");
      if (active === "Apartments") fetchProperties("apartment");
      return;
    }

    if (active === "Villas") {
      fetchProperties("villa");
    }
    if (active === "Hotels") {
      setCurrentPage_hotel(1);
      fetchProperties("hotel");
    }
    if (active === "Resorts") {
      setCurrentPage_resort(1);
      fetchProperties("resort");
    }
    if (active === "Apartments") {
      setCurrentPage_apartment(1);
      fetchProperties("apartment");
    }
  }, [active]);

  useEffect(() => {
    if (searchQuery !== "") {
      if (active === "Villas") setCurrentPage_villa(1);
      if (active === "Hotels") setCurrentPage_hotel(1);
      if (active === "Resorts") setCurrentPage_resort(1);
      if (active === "Apartments") setCurrentPage_apartment(1);
    }
  }, [searchQuery]);
  const [selectedRows_resort, setSelectedRows_resort] = useState([]);

  const handleRowCheckboxChange_resort = (order) => {
    setSelectedRows_resort((prevSelected) =>
      prevSelected.includes(order)
        ? prevSelected.filter((id) => id !== order)
        : [...prevSelected, order],
    );
  };

  const handleSelectAll_resort = () => {
    if (selectedRows_resort.length === current_property_resort.length) {
      setSelectedRows_resort([]);
    } else {
      setSelectedRows_resort(
        current_property_resort.map((booking) => booking.order),
      );
    }
  };

  const handleToggle_topProperty_resort = async (order) => {
    const resort = table_property_resort.find((item) => item.order === order);
    const newEnabled = !resort.topPropertyEnabled;

    if (!newEnabled) {
      // Turning OFF → clear in DB
      try {
        const res = await axios.post(
          "https://demo.zorbastays.com/web-backend/update-rank",
          {
            propertyid: order,
            propertytype: "resort",
            rank: 0,
          },
        );

        if (res.data.success) {
          const updated = table_property_resort.map((item) =>
            item.order === order
              ? { ...item, topPropertyEnabled: false, topPropertyValue: "" }
              : item,
          );
          setTableProperty_resort(updated);
          await refreshResortRanks();
        } else {
          alert(res.data.message);
        }
      } catch (err) {
        console.error("Failed to reset top property (resort)", err);
        alert("Error updating top property toggle");
      }
    } else {
      // Turning ON → just enable, wait for dropdown
      const updated = table_property_resort.map((item) =>
        item.order === order
          ? { ...item, topPropertyEnabled: true, topPropertyValue: "" }
          : item,
      );
      setTableProperty_resort(updated);
    }
  };

  const handleDropdownChange_topProperty_resort = async (order, value) => {
    // const resort = table_property_resort.find((item) => item.order === order);

    try {
      const res = await axios.post(
        "https://demo.zorbastays.com/web-backend/update-rank",
        {
          propertyid: order,
          propertytype: "resort",
          rank: parseInt(value, 10), // ensure number
        },
      );

      if (res.data.success) {
        const updated = table_property_resort.map((item) =>
          item.order === order ? { ...item, topPropertyValue: value } : item,
        );
        setTableProperty_resort(updated);
        await fetchProperties(); // refresh Resorts table
        await refreshResortRanks();
      } else {
        alert(res.data.message);
      }
    } catch (err) {
      console.error("Failed to update resort rank", err);
      alert("Error updating resort rank");
    }
  };

  const [isOpen_dropdownExp, setIsOpen_dropdownExp] = useState(false);
  const [selectedOptions_dropdownExp, setSelectedOptions_dropdownExp] =
    useState([]);
  const dropdownRef_dropdownExp = useRef(null);

  const options_dropdownExp = ["Option1", "Option2", "Option3"];

  const toggleOption_dropdownExp = (option) => {
    setSelectedOptions_dropdownExp((prev) =>
      prev.includes(option)
        ? prev.filter((item) => item !== option)
        : [...prev, option],
    );
  };

  useEffect(() => {
    const handleClickOutside_dropdownExp = (event) => {
      if (
        dropdownRef_dropdownExp.current &&
        !dropdownRef_dropdownExp.current.contains(event.target)
      ) {
        setIsOpen_dropdownExp(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside_dropdownExp);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside_dropdownExp);
  }, []);

  // const handleDeleteProperty = (propertyid) => {
  //   confirmAlert({
  //     customUI: ({ onClose }) => {
  //       return (
  //         <div className="bg-white p-6 rounded-lg shadow-lg text-center">
  //           <h2 className="text-xl font-semibold mb-4">Confirm Deletion</h2>
  //           <p className="text-gray-600 mb-6">
  //             Are you sure you want to delete this property?
  //           </p>

  //           <div className="flex justify-center space-x-4">
  //             {/* Cancel */}
  //             <button
  //               onClick={onClose}
  //               className="px-5 py-2 rounded-md bg-gray-800 text-white hover:bg-gray-700 transition"
  //             >
  //               Keep It
  //             </button>

  //             {/* Delete */}
  //             <button
  //               onClick={async () => {
  //                 try {
  //                   const res = await axios.delete(
  //                     `https://demo.zorbastays.com/web-backend/${propertyid}`
  //                   );

  //                   if (res.data.success) {
  //                     toast.success("Property deleted successfully 🗑️");

  //                     // refresh list
  //                     if (active === "Villas") fetchProperties("villa");
  //                     if (active === "Hotels") fetchProperties("hotel");
  //                     if (active === "Resorts") fetchProperties("resort");
  //                   } else {
  //                     toast.error(
  //                       res.data.error || "Failed to delete property"
  //                     );
  //                   }
  //                 } catch (err) {
  //                   console.error("Delete error:", err);
  //                   toast.error("Error deleting property");
  //                 }
  //                 onClose();
  //               }}
  //               className="px-5 py-2 flex items-center gap-2 rounded-md bg-red-600 text-white hover:bg-black transition"
  //             >
  //               <FaTrash />
  //               Delete
  //             </button>
  //           </div>
  //         </div>
  //       );
  //     },
  //   });
  // };
  const RatingConfirmation = ({ onClose, onConfirm, rating, propertyname }) => {
    const [isSaving, setIsSaving] = useState(false);

    const handleConfirm = async () => {
      setIsSaving(true);
      await onConfirm();
      setIsSaving(false);
      onClose();
    };

    return (
      <div className="bg-white p-6 rounded-lg shadow-lg text-center max-w-sm">
        <h2 className="text-xl font-semibold mb-4">Confirm Rating</h2>
        <p className="text-gray-600 mb-2">
          Set rating for{" "}
          <span className="font-semibold text-black">{propertyname}</span> to:
        </p>
        <div className="flex justify-center gap-1 mb-6">
          {[1, 2, 3, 4, 5].map((star) => (
            <FaStar
              key={star}
              size={22}
              className={star <= rating ? "text-yellow-400" : "text-gray-300"}
            />
          ))}
        </div>

        <div className="flex justify-center space-x-4">
          <button
            onClick={onClose}
            disabled={isSaving}
            className="px-5 py-2 rounded-md bg-gray-800 text-white disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Cancel
          </button>
          <button
            onClick={handleConfirm}
            disabled={isSaving}
            className="px-5 py-2 flex items-center gap-2 rounded-md bg-green-700 text-white hover:bg-black transition disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isSaving ? "Saving..." : "Confirm"}
          </button>
        </div>
      </div>
    );
  };
  const DeleteConfirmation = ({ onClose, propertyid }) => {
    const [isDeleting, setIsDeleting] = useState(false);

    const handleDelete = async () => {
      setIsDeleting(true);
      try {
        const url =
          active === "Hotels"
            ? `https://demo.zorbastays.com/web-backend/deleteHotel/${propertyid}`
            : `https://demo.zorbastays.com/web-backend/${propertyid}`;

        const res = await axios.delete(url);

        if (res.data.success) {
          toast.success("Property deleted successfully 🗑️");
          if (active === "Villas") fetchProperties("villa");
          if (active === "Hotels") fetchProperties("hotel");
          if (active === "Resorts") fetchProperties("resort");
        } else {
          toast.error(res.data.error || "Failed to delete");
        }
      } catch (err) {
        console.error("Delete error:", err);
        toast.error("Error deleting property");
      } finally {
        setIsDeleting(false);
        onClose();
      }
    };

    return (
      <div className="bg-white p-6 rounded-lg shadow-lg text-center">
        <h2 className="text-xl font-semibold mb-4">Confirm Deletion</h2>
        <p className="text-gray-600 mb-6">
          Are you sure you want to delete this property?
        </p>

        <div className="flex justify-center space-x-4">
          <button
            onClick={onClose}
            disabled={isDeleting}
            className="px-5 py-2 rounded-md bg-gray-800 text-white disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Keep It
          </button>
          <button
            onClick={handleDelete}
            disabled={isDeleting}
            className="px-5 py-2 flex items-center gap-2 rounded-md bg-red-600 text-white hover:bg-black transition disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isDeleting ? (
              <>
                <svg
                  className="animate-spin h-4 w-4"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                Deleting...
              </>
            ) : (
              <>
                <FaTrash /> Delete
              </>
            )}
          </button>
        </div>
      </div>
    );
  };

  const handleDeleteProperty = (propertyid) => {
    confirmAlert({
      customUI: ({ onClose }) => (
        <DeleteConfirmation onClose={onClose} propertyid={propertyid} />
      ),
    });
  };
  // const handleDeleteProperty = (propertyid) => {
  //   confirmAlert({
  //     customUI: ({ onClose }) => (
  //       <div className="bg-white p-6 rounded-lg shadow-lg text-center">
  //         <h2 className="text-xl font-semibold mb-4">Confirm Deletion</h2>
  //         <p className="text-gray-600 mb-6">
  //           Are you sure you want to delete this property?
  //         </p>

  //         <div className="flex justify-center space-x-4">
  //           <button
  //             onClick={onClose}
  //             className="px-5 py-2 rounded-md bg-gray-800 text-white"
  //           >
  //             Keep It
  //           </button>
  //           <button
  //             onClick={async () => {
  //               try {
  //                 const url =
  //                   active === "Hotels"
  //                     ? `https://demo.zorbastays.com/web-backend/deleteHotel/${propertyid}`
  //                     : `https://demo.zorbastays.com/web-backend/${propertyid}`;

  //                 const res = await axios.delete(url);

  //                 if (res.data.success) {
  //                   toast.success("Deleted successfully 🗑️");
  //                   if (active === "Villas") fetchProperties("villa");
  //                   if (active === "Hotels") fetchProperties("hotel");
  //                   if (active === "Resorts") fetchProperties("resort");
  //                 } else {
  //                   toast.error(res.data.error || "Failed to delete");
  //                 }
  //               } catch (err) {
  //                 console.error("Delete error:", err);
  //                 toast.error("Error deleting property");
  //               }
  //               onClose();
  //             }}
  //             className="px-5 py-2 flex items-center gap-2 rounded-md bg-red-600 text-white hover:bg-black transition"
  //           >
  //             <FaTrash /> Delete
  //           </button>
  //         </div>
  //       </div>
  //     ),
  //   });
  // };

  const handleToggle_topFive_villa = async (order) => {
    const villa = table_property_villa.find((item) => item.order === order);
    const newEnabled = !villa.topFiveEnabled;

    if (!newEnabled) {
      // Turn off → clear in DB
      try {
        const res = await axios.post(
          "https://demo.zorbastays.com/web-backend/update-rank",
          {
            propertyid: order,
            propertytype: "villa",
            rank: 0,
            mode: "topFive",
          },
        );

        if (res.data.success) {
          setTableProperty_villa((prev) =>
            prev.map((i) =>
              i.order === order
                ? { ...i, topFiveEnabled: false, topFiveValue: "" }
                : i,
            ),
          );
          // Refresh available global ranks
          const res2 = await axios.get(
            "https://demo.zorbastays.com/web-backend/getTakenTopFive",
          );
          if (res2.data.success) {
            const taken = res2.data.taken || [];
            const allRanks = [1, 2, 3, 4, 5];
            const freeRanks = allRanks.filter((r) => !taken.includes(r));
            setAvailableRanks(freeRanks);
          }
        } else {
          alert(res.data.message);
        }
      } catch (err) {
        console.error("Failed to reset global top 5", err);
      }
    } else {
      // Just enable toggle in UI
      setTableProperty_villa((prev) =>
        prev.map((i) =>
          i.order === order
            ? { ...i, topFiveEnabled: true, topFiveValue: "" }
            : i,
        ),
      );
    }
  };

  const handleDropdownChange_topFive_villa = async (order, value) => {
    try {
      const res = await axios.post(
        "https://demo.zorbastays.com/web-backend/update-rank",
        {
          propertyid: order,
          propertytype: "villa", // still pass type, though backend ignores in topFive mode
          rank: parseInt(value, 10),
          mode: "topFive",
        },
      );

      if (res.data.success) {
        setTableProperty_villa((prev) =>
          prev.map((i) =>
            i.order === order ? { ...i, topFiveValue: value } : i,
          ),
        );
      } else {
        alert(res.data.message);
      }
      window.location.reload();
    } catch (err) {
      console.error("Failed to update global top 5 rank", err);
    }
  };
  const handleToggle_topFive_hotel = async (order) => {
    const hotel = table_property_hotel.find((item) => item.order === order);
    const newEnabled = !hotel.topFiveEnabled;

    if (!newEnabled) {
      try {
        const res = await axios.post(
          "https://demo.zorbastays.com/web-backend/update-rank",
          {
            propertyid: order,
            propertytype: "hotel",
            rank: 0,
            mode: "topFive",
          },
        );
        if (res.data.success) {
          setTableProperty_hotel((prev) =>
            prev.map((i) =>
              i.order === order
                ? { ...i, topFiveEnabled: false, topFiveValue: "" }
                : i,
            ),
          );
        }
      } catch (err) {
        console.error("Failed to reset global top 5 (hotel)", err);
      }
    } else {
      setTableProperty_hotel((prev) =>
        prev.map((i) =>
          i.order === order
            ? { ...i, topFiveEnabled: true, topFiveValue: "" }
            : i,
        ),
      );
    }
  };

  const handleDropdownChange_topFive_hotel = async (order, value) => {
    try {
      const res = await axios.post(
        "https://demo.zorbastays.com/web-backend/update-rank",
        {
          propertyid: order,
          propertytype: "hotel",
          rank: parseInt(value, 10),
          mode: "topFive",
        },
      );

      if (res.data.success) {
        setTableProperty_hotel((prev) =>
          prev.map((i) =>
            i.order === order ? { ...i, topFiveValue: value } : i,
          ),
        );
      } else {
        alert(res.data.message);
      }
      window.location.reload();
    } catch (err) {
      console.error("Failed to update global top 5 rank (hotel)", err);
    }
  };
  const handleToggle_topFive_resort = async (order) => {
    const resort = table_property_resort.find((item) => item.order === order);
    const newEnabled = !resort.topFiveEnabled;

    if (!newEnabled) {
      try {
        const res = await axios.post(
          "https://demo.zorbastays.com/web-backend/update-rank",
          {
            propertyid: order,
            propertytype: "resort",
            rank: 0,
            mode: "topFive",
          },
        );
        if (res.data.success) {
          setTableProperty_resort((prev) =>
            prev.map((i) =>
              i.order === order
                ? { ...i, topFiveEnabled: false, topFiveValue: "" }
                : i,
            ),
          );
        }
      } catch (err) {
        console.error("Failed to reset global top 5 (resort)", err);
      }
    } else {
      setTableProperty_resort((prev) =>
        prev.map((i) =>
          i.order === order
            ? { ...i, topFiveEnabled: true, topFiveValue: "" }
            : i,
        ),
      );
    }
  };

  const handleDropdownChange_topFive_resort = async (order, value) => {
    try {
      const res = await axios.post(
        "https://demo.zorbastays.com/web-backend/update-rank",
        {
          propertyid: order,
          propertytype: "resort",
          rank: parseInt(value, 10),
          mode: "topFive",
        },
      );

      if (res.data.success) {
        setTableProperty_resort((prev) =>
          prev.map((i) =>
            i.order === order ? { ...i, topFiveValue: value } : i,
          ),
        );
      } else {
        alert(res.data.message);
      }
      window.location.reload();
    } catch (err) {
      console.error("Failed to update global top 5 rank (resort)", err);
    }
  };
  const [availableRanks, setAvailableRanks] = useState([]);

  useEffect(() => {
    const fetchAvailableRanks = async () => {
      try {
        const res = await axios.get(
          "https://demo.zorbastays.com/web-backend/getTakenTopFive",
        );
        if (res.data.success) {
          const taken = res.data.taken;
          const allRanks = [1, 2, 3, 4, 5];
          const freeRanks = allRanks.filter((r) => !taken.includes(r));
          setAvailableRanks(freeRanks);
        }
      } catch (err) {
        console.error("Failed to fetch available ranks", err);
      }
    };

    fetchAvailableRanks();
  }, []);

  const RankToggle = ({
    enabled,
    value,
    onToggle,
    onChange,
    availableRanks,
  }) => {
    const controlWidth = "w-[72px]"; // shared width

    return (
      <div className="flex flex-col items-start gap-2 group">
        {/* Toggle */}
        <button
          type="button"
          onClick={onToggle}
          className={`relative inline-flex h-7 ${controlWidth} items-center rounded-full transition-colors ${
            enabled ? "bg-green-500" : "bg-gray-300"
          }`}
        >
          {/* Label inside toggle */}
          {enabled ? (
            <span className="absolute left-2 text-[10px] font-medium text-white">
              {value ? `Rank: ${value}` : "On"}
            </span>
          ) : (
            <span className="absolute right-2 text-[10px] font-medium text-white">
              Off
            </span>
          )}

          {/* Knob */}
          <span
            className={`inline-block h-5 w-5 transform rounded-full bg-white transition-transform ${
              enabled ? "translate-x-12" : "translate-x-1"
            }`}
          />
        </button>

        {/* Dropdown → only visible when toggle is ON + hovered */}
        {enabled && (
          <select
            className={`${controlWidth} text-xs border border-gray-400 rounded px-1 py-0.5 focus:outline-none focus:ring-1 focus:ring-green-500 hidden group-hover:block`}
            value={value}
            onChange={(e) => onChange(e.target.value)}
          >
            <option value="">Select Rank</option>
            {[...new Set([value, ...availableRanks])]
              .filter(Boolean)
              .sort((a, b) => a - b)
              .map((rank) => (
                <option key={rank} value={rank}>
                  {rank}
                </option>
              ))}
          </select>
        )}
      </div>
    );
  };
  const [availableVillaRanks, setAvailableVillaRanks] = useState([
    1, 2, 3, 4, 5,
  ]);
  const [availableHotelRanks, setAvailableHotelRanks] = useState([
    1, 2, 3, 4, 5,
  ]);
  const [availableResortRanks, setAvailableResortRanks] = useState([
    1, 2, 3, 4, 5,
  ]);

  useEffect(() => {
    if (active === "Villas") {
      axios
        .get(
          "https://demo.zorbastays.com/web-backend/getTakenTopProperty?propertytype=villa",
        )
        .then((res) => {
          if (res.data.success) {
            const allRanks = [1, 2, 3, 4, 5];
            const taken = res.data.taken || [];
            const available = allRanks.filter((r) => !taken.includes(r));
            setAvailableVillaRanks(available);
          }
        })
        .catch((err) =>
          console.error("Failed to fetch available villa ranks", err),
        );
    }
  }, [active]);
  useEffect(() => {
    if (active === "Hotels") {
      axios
        .get(
          "https://demo.zorbastays.com/web-backend/getTakenTopProperty?propertytype=hotel",
        )
        .then((res) => {
          if (res.data.success) {
            const allRanks = [1, 2, 3, 4, 5];
            const taken = res.data.taken || [];
            const available = allRanks.filter((r) => !taken.includes(r));
            setAvailableHotelRanks(available);
          }
        })
        .catch((err) =>
          console.error("Failed to fetch available hotel ranks", err),
        );
    }
  }, [active]);

  useEffect(() => {
    if (active === "Resorts") {
      axios
        .get(
          "https://demo.zorbastays.com/web-backend/getTakenTopProperty?propertytype=resort",
        )
        .then((res) => {
          if (res.data.success) {
            const allRanks = [1, 2, 3, 4, 5];
            const taken = res.data.taken || [];
            const available = allRanks.filter((r) => !taken.includes(r));
            setAvailableResortRanks(available);
          }
        })
        .catch((err) =>
          console.error("Failed to fetch available resort ranks", err),
        );
    }
  }, [active]);
  const [availableApartmentRanks, setAvailableApartmentRanks] = useState([
    1, 2, 3, 4, 5,
  ]);

  // Add this useEffect for apartments
  useEffect(() => {
    if (active === "Apartments") {
      axios
        .get(
          "https://demo.zorbastays.com/web-backend/getTakenTopProperty?propertytype=apartment",
        )
        .then((res) => {
          if (res.data.success) {
            const allRanks = [1, 2, 3, 4, 5];
            const taken = res.data.taken || [];
            const available = allRanks.filter((r) => !taken.includes(r));
            setAvailableApartmentRanks(available);
          }
        })
        .catch((err) =>
          console.error("Failed to fetch available apartment ranks", err),
        );
    }
  }, [active]);

  // Add these handler functions for apartments
  const handleToggle_topProperty_apartment = async (order) => {
    const apartment = table_property_apartment.find(
      (item) => item.order === order,
    );
    const newEnabled = !apartment.topPropertyEnabled;

    if (!newEnabled) {
      // Turning OFF → clear in DB
      try {
        const res = await axios.post(
          "https://demo.zorbastays.com/web-backend/update-rank",
          {
            propertyid: order,
            propertytype: "apartment",
            rank: 0,
          },
        );

        if (res.data.success) {
          const updated = table_property_apartment.map((item) =>
            item.order === order
              ? { ...item, topPropertyEnabled: false, topPropertyValue: "" }
              : item,
          );
          setTableProperty_apartment(updated);
          // Refresh available apartment ranks
          const res2 = await axios.get(
            "https://demo.zorbastays.com/web-backend/getTakenTopProperty?propertytype=apartment",
          );
          if (res2.data.success) {
            const allRanks = [1, 2, 3, 4, 5];
            const taken = res2.data.taken || [];
            const available = allRanks.filter((r) => !taken.includes(r));
            setAvailableApartmentRanks(available);
          }
        } else {
          alert(res.data.message);
        }
      } catch (err) {
        console.error("Failed to reset top property (apartment)", err);
        alert("Error updating top property toggle");
      }
    } else {
      // Turning ON → just enable, wait for dropdown
      const updated = table_property_apartment.map((item) =>
        item.order === order
          ? { ...item, topPropertyEnabled: true, topPropertyValue: "" }
          : item,
      );
      setTableProperty_apartment(updated);
    }
  };

  const handleDropdownChange_topProperty_apartment = async (order, value) => {
    try {
      const res = await axios.post(
        "https://demo.zorbastays.com/web-backend/update-rank",
        {
          propertyid: order,
          propertytype: "apartment",
          rank: parseInt(value, 10),
        },
      );

      if (res.data.success) {
        const updated = table_property_apartment.map((item) =>
          item.order === order ? { ...item, topPropertyValue: value } : item,
        );
        setTableProperty_apartment(updated);
        await fetchProperties(); // refresh Apartments table
        // Refresh available apartment ranks
        const res2 = await axios.get(
          "https://demo.zorbastays.com/web-backend/getTakenTopProperty?propertytype=apartment",
        );
        if (res2.data.success) {
          const allRanks = [1, 2, 3, 4, 5];
          const taken = res2.data.taken || [];
          const available = allRanks.filter((r) => !taken.includes(r));
          setAvailableApartmentRanks(available);
        }
      } else {
        alert(res.data.message);
      }
    } catch (err) {
      console.error("Failed to update apartment rank", err);
      alert("Error updating apartment rank");
    }
  };

  const handleToggle_topFive_apartment = async (order) => {
    const apartment = table_property_apartment.find(
      (item) => item.order === order,
    );
    const newEnabled = !apartment.topFiveEnabled;

    if (!newEnabled) {
      try {
        const res = await axios.post(
          "https://demo.zorbastays.com/web-backend/update-rank",
          {
            propertyid: order,
            propertytype: "apartment",
            rank: 0,
            mode: "topFive",
          },
        );
        if (res.data.success) {
          setTableProperty_apartment((prev) =>
            prev.map((i) =>
              i.order === order
                ? { ...i, topFiveEnabled: false, topFiveValue: "" }
                : i,
            ),
          );
          // Refresh available global ranks
          const res2 = await axios.get(
            "https://demo.zorbastays.com/web-backend/getTakenTopFive",
          );
          if (res2.data.success) {
            const taken = res2.data.taken || [];
            const allRanks = [1, 2, 3, 4, 5];
            const freeRanks = allRanks.filter((r) => !taken.includes(r));
            setAvailableRanks(freeRanks);
          }
        }
      } catch (err) {
        console.error("Failed to reset global top 5 (apartment)", err);
      }
    } else {
      setTableProperty_apartment((prev) =>
        prev.map((i) =>
          i.order === order
            ? { ...i, topFiveEnabled: true, topFiveValue: "" }
            : i,
        ),
      );
    }
  };

  const handleDropdownChange_topFive_apartment = async (order, value) => {
    try {
      const res = await axios.post(
        "https://demo.zorbastays.com/web-backend/update-rank",
        {
          propertyid: order,
          propertytype: "apartment",
          rank: parseInt(value, 10),
          mode: "topFive",
        },
      );

      if (res.data.success) {
        setTableProperty_apartment((prev) =>
          prev.map((i) =>
            i.order === order ? { ...i, topFiveValue: value } : i,
          ),
        );
        // Refresh available global ranks instead of reloading
        const res2 = await axios.get(
          "https://demo.zorbastays.com/web-backend/getTakenTopFive",
        );
        if (res2.data.success) {
          const taken = res2.data.taken || [];
          const allRanks = [1, 2, 3, 4, 5];
          const freeRanks = allRanks.filter((r) => !taken.includes(r));
          setAvailableRanks(freeRanks);
        }
      } else {
        alert(res.data.message);
      }
    } catch (err) {
      console.error("Failed to update global top 5 rank (apartment)", err);
    }
  };
  const handleAddProperty = () => {
    if (active === "Hotels") {
      navigate("/AddHotelElementor");
    } else {
      navigate("/AddPropertyDetailElementor");
    }
  };
  const [analytics, setAnalytics] = useState({
    totalvillas: 0,
    totalhotels: 0,
    avgscore: 0,
  });

  useEffect(() => {
    const fetchAnalytics = async () => {
      try {
        const res = await axios.get(
          "https://demo.zorbastays.com/web-backend/property-completion-box",
        );

        if (res.data.success) {
          setAnalytics(res.data.analytics);
        }
      } catch (err) {
        console.error("Error fetching analytics:", err);
      }
    };

    fetchAnalytics();
  }, []);

  // format numbers with commas
  const formatNumber = (num) =>
    new Intl.NumberFormat("en-IN").format(Number(num));

  const handleAvailabilityToggle = async (item) => {
    const newAvailability = item.availability ? 0 : 1;
    const propertytype = active === "Hotels" ? "hotel" : "villa";

    // Optimistically update UI first
    const updateState =
      active === "Hotels" ? setTableProperty_hotel : setTableProperty_villa;
    updateState((prev) =>
      prev.map((row) =>
        row.order === item.order
          ? { ...row, availability: newAvailability }
          : row,
      ),
    );

    try {
      const res = await axios.post(
        "https://demo.zorbastays.com/web-backend/update-availability",
        {
          propertyid: item.order,
          availability: newAvailability,
        },
      );

      if (!res.data.success) {
        // revert on failure
        updateState((prev) =>
          prev.map((row) =>
            row.order === item.order
              ? { ...row, availability: item.availability }
              : row,
          ),
        );
        alert(res.data.message || "Failed to update availability");
      }
    } catch (err) {
      console.error("Failed to update availability", err);
      // revert on error
      updateState((prev) =>
        prev.map((row) =>
          row.order === item.order
            ? { ...row, availability: item.availability }
            : row,
        ),
      );
      alert("Error updating availability");
    }
  };
  const handleRatingChange = async (order, propertytype, rating) => {
    const updateState =
      propertytype === "hotel"
        ? setTableProperty_hotel
        : setTableProperty_villa;

    // optimistic UI update
    updateState((prev) =>
      prev.map((item) => (item.order === order ? { ...item, rating } : item)),
    );

    try {
      const res = await axios.post(
        "https://demo.zorbastays.com/web-backend/update-rating",
        { propertyid: order, rating },
      );
      if (res.data.success) {
        toast.success("Rating updated successfully ⭐");
      } else {
        alert(res.data.message || "Failed to update rating");
        updateState((prev) =>
          prev.map((item) =>
            item.order === order ? { ...item, rating: item.rating } : item,
          ),
        );
      }
    } catch (err) {
      console.error("Failed to update rating", err);
      alert("Error updating rating");
    }
  };
  const confirmRatingChange = (order, propertytype, rating, propertyname) => {
    confirmAlert({
      customUI: ({ onClose }) => (
        <RatingConfirmation
          onClose={onClose}
          rating={rating}
          propertyname={propertyname}
          onConfirm={() => handleRatingChange(order, propertytype, rating)}
        />
      ),
    });
  };
  return (
    <div className="flex bg-[#F8F9FA]">
      <Menubar
        isOpen={isSidebarOpen}
        setIsOpen={setIsSidebarOpen}
        isMobile={isMobile}
      />

      <main
        className={`p-5 lg:p-6 transition-all duration-500 w-full ${
          isMobile ? "ml-0" : isSidebarOpen ? "ml-64" : "ml-16"
        }`}
      >
        <Outlet />

        {/* Header */}
        <div className="flex justify-between gap-5 items-start lg:items-center">
          <div className="flex flex-col lg:flex-row gap-5 items-start lg:items-center">
            <p className="font-semibold text-xl text-gray-700 ml-10 lg:ml-0">
              Properties
            </p>
          </div>

          <div className="flex items-center gap-1">
            <div className="flex items-center">
              <div className="mr-2 p-2 overflow-hidden w-8 h-8 hover:w-[120px] sm:hover:w-[250px] hover:border hover:border-[#1D2826] hover:shadow-[2px_2px_20px_rgba(0,0,0,0.08)] rounded-full flex group items-center hover:duration-300 duration-300">
                <div className="flex items-center justify-center fill-[#1D2826]">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    id="Isolation_Mode"
                    data-name="Isolation Mode"
                    viewBox="0 0 24 24"
                    width="18"
                    height="18"
                  >
                    <path d="M18.9,16.776A10.539,10.539,0,1,0,16.776,18.9l5.1,5.1L24,21.88ZM10.5,18A7.5,7.5,0,1,1,18,10.5,7.507,7.507,0,0,1,10.5,18Z"></path>
                  </svg>
                </div>
                <input
                  type="text"
                  placeholder={`Search In ${active}...`}
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="border-none outline-none text-sm bg-transparent w-full font-normal px-2 focus:ring-0"
                />
              </div>
            </div>
          </div>
        </div>
        {/* Boxes */}
        <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 items-center gap-5 text-gray-700 font-semibold mt-5">
          <div className="flex items-center justify-between gap-5 bg-[#DAE0CE] py-2 px-4 rounded-lg">
            <div>
              <p>Total Villas</p>
              <p className="mt-2 text-lg text-black">
                {formatNumber(analytics.totalvillas)}
                {/* <sup className="text-green-500">+55%</sup> */}
              </p>
            </div>

            <div>
              <MdHolidayVillage className="bg-[#3C4C4E] text-3xl text-white p-1.5 rounded-md" />
            </div>
          </div>

          <div className="flex items-center justify-between gap-5 bg-[#DAE0CE] py-2 px-4 rounded-lg">
            <div>
              <p>Total Hotels </p>
              <p className="mt-2 text-lg text-black">
                {formatNumber(analytics.totalhotels)}
                {/* <sup className="text-green-500">+5%</sup> */}
              </p>
            </div>

            <div>
              <FaHotel className="bg-[#3C4C4E] text-3xl text-white p-1.5 rounded-md" />
            </div>
          </div>

          <div className="flex items-center justify-between gap-5 bg-[#DAE0CE] py-2 px-4 rounded-lg">
            <div>
              <p>Average Score</p>
              <p className="mt-2 text-lg text-black">
                {analytics.avgscore}%
                {/* <sup className="text-green-500">+8%</sup> */}
              </p>
            </div>

            <div>
              <VscPercentage className="bg-[#3C4C4E] text-3xl text-white p-1.5 rounded-md" />
            </div>
          </div>
        </div>
        {/* Segmented buttons */}
        <div className=" flex flex-col sm:flex-row sm:items-center justify-between gap-5 mt-8">
          <div>
            <div className="inline-flex border border-gray-300 rounded-lg overflow-hidden text-sm font-medium shadow-sm">
              {options.map((option) => (
                <button
                  key={option}
                  onClick={() => setActive(option)}
                  className={`px-4 py-2 transition-colors duration-200 focus:outline-none ${
                    active === option
                      ? "bg-[#1D2826] text-white"
                      : "bg-white text-gray-500 hover:bg-green-50"
                  }`}
                >
                  {option}
                </button>
              ))}
            </div>
          </div>

          {/* Button */}
          <div className="flex gap-2">
            <button
              onClick={() => window.open("/SmartScheduler", "_blank")}
              className="flex items-center gap-2 px-6 z-30 py-2 border-2 border-[#1D2826] text-[#1D2826] rounded-lg text-center hover:text-white relative hover:scale-95 after:-z-20 after:absolute after:h-1 after:w-1 after:bg-green-900 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-500 after:transition-all after:duration-700 transition-all duration-700 text-sm"
            >
              <FaWandMagicSparkles /> <span>Smart Scheduler</span>
            </button>
            <button
              onClick={handleAddProperty}
              className="px-6 z-30 py-2 bg-[#1D2826] rounded-lg text-center text-white relative hover:scale-95 after:-z-20 after:absolute after:h-1 after:w-1 after:bg-green-900 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700 transition-all duration-700 text-sm"
            >
              + Add Property
            </button>

            <div className="relative z-50">
              {isOpen_popupForm && (
                <div
                  onClick={() => setIsOpen_popupForm(false)}
                  className="fixed inset-0 bg-black bg-opacity-30 z-40 backdrop_popupForm"
                />
              )}

              <div
                className={`fixed top-0 right-0 h-full w-[85%] md:w-[640px] bg-white z-50 shadow-lg transform transition-transform duration-500 ease-in-out ${
                  isOpen_popupForm ? "translate-x-0" : "translate-x-full"
                } panel_popupForm`}
              >
                <div className="p-4 flex justify-between items-center border-b header_popupForm">
                  <h2 className="text-[#1D2826] text-lg font-semibold">
                    Add New Property
                  </h2>
                  <button
                    onClick={() => setIsOpen_popupForm(false)}
                    className="text-gray-500 hover:text-black text-xl"
                  >
                    <MdCancel />
                  </button>
                </div>

                <div className="p-4">
                  <div className="font-semibold text-gray-500 text-sm text-right">
                    Property ID:{" "}
                    <span className="text-black my-1">10294837</span>
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-5 gap-y-3 items-center max-h-[85vh] overflow-y-auto py-2">
                    <div className="flex flex-col w-full">
                      <label
                        for="input"
                        className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
                      >
                        Property Name
                      </label>
                      <input
                        placeholder="Enter property name"
                        name="input"
                        className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                      />
                    </div>

                    <div className="flex flex-col w-full">
                      <label
                        for="input"
                        className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
                      >
                        Property Code
                      </label>
                      <input
                        placeholder="Enter property code"
                        name="input"
                        className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                      />
                    </div>

                    <div className="flex flex-col w-full">
                      <label
                        for="input"
                        className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
                      >
                        Headline
                      </label>
                      <textarea
                        placeholder="Enter headline"
                        rows="3"
                        className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                      />
                    </div>

                    <div className="flex flex-col w-full">
                      <label
                        for="input"
                        className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
                      >
                        Description
                      </label>
                      <textarea
                        placeholder="Enter description"
                        rows="3"
                        className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                      />
                    </div>

                    <div className="flex flex-col w-full">
                      <label
                        for="input"
                        className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
                      >
                        Current Price
                      </label>
                      <input
                        placeholder="Enter current price"
                        name="input"
                        className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                      />
                    </div>

                    <div className="flex flex-col w-full">
                      <label
                        for="input"
                        className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
                      >
                        Default Price
                      </label>
                      <input
                        placeholder="Enter default price"
                        name="input"
                        className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                      />
                    </div>

                    <div className="flex flex-col w-full">
                      <label
                        for="input"
                        className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
                      >
                        Security Deposit
                      </label>
                      <input
                        placeholder="Enter security deposit"
                        name="input"
                        className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                      />
                    </div>

                    <div className="flex flex-col w-full">
                      <label
                        for="input"
                        className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
                      >
                        Max Adults
                      </label>
                      <input
                        placeholder="Enter max adults"
                        name="input"
                        className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                      />
                    </div>

                    <div className="flex flex-col w-full">
                      <label
                        for="input"
                        className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
                      >
                        Max Children
                      </label>
                      <input
                        placeholder="Enter max children"
                        name="input"
                        className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                      />
                    </div>

                    <div className="flex flex-col w-full">
                      <label
                        for="input"
                        className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
                      >
                        Max Bedroom
                      </label>
                      <input
                        placeholder="Enter max bedroom"
                        name="input"
                        className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                      />
                    </div>

                    <div className="flex flex-col w-full">
                      <label
                        for="input"
                        className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
                      >
                        Max Bathroom
                      </label>
                      <input
                        placeholder="Enter max bathroom"
                        name="input"
                        className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                      />
                    </div>

                    <div className="flex flex-col w-full">
                      <label
                        for="input"
                        className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
                      >
                        Map Location
                      </label>
                      <input
                        placeholder="Enter map location"
                        name="input"
                        className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                      />
                    </div>

                    <div className="flex flex-col w-full">
                      <label
                        for="input"
                        className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
                      >
                        Youtube Link
                      </label>
                      <input
                        placeholder="Enter youtube link"
                        name="input"
                        className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                      />
                    </div>

                    <div className="flex flex-col w-full">
                      <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit">
                        Select Location
                      </label>

                      <select className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md">
                        <option value="">Select your location</option>
                        <option value="">option1</option>
                        <option value="">option2</option>
                        <option value="">option3</option>
                      </select>
                    </div>

                    <div className="flex flex-col w-full">
                      <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit">
                        Property Type
                      </label>

                      <select className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md">
                        <option value="">Select your property type</option>
                        <option value="">option1</option>
                        <option value="">option2</option>
                        <option value="">option3</option>
                      </select>
                    </div>

                    <div
                      className="relative w-full"
                      ref={dropdownRef_dropdownExp}
                    >
                      <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit">
                        Experience
                      </label>

                      <div
                        onClick={() => setIsOpen_dropdownExp((prev) => !prev)}
                        className="border border-gray-400 p-3 rounded-lg w-full cursor-pointer text-sm bg-white focus:outline-none"
                      >
                        {selectedOptions_dropdownExp.length > 0
                          ? selectedOptions_dropdownExp.join(", ")
                          : "Select your experience(s)"}
                      </div>

                      {isOpen_dropdownExp && (
                        <div className="absolute top-full left-0 w-full bg-white border border-gray-300 mt-1 rounded-md shadow-md z-10">
                          {options_dropdownExp.map((option) => (
                            <label
                              key={option}
                              className="flex items-center gap-2 px-4 py-2 text-sm hover:bg-gray-100 cursor-pointer"
                            >
                              <input
                                type="checkbox"
                                checked={selectedOptions_dropdownExp.includes(
                                  option,
                                )}
                                onChange={() =>
                                  toggleOption_dropdownExp(option)
                                }
                                className="accent-black"
                              />
                              {option}
                            </label>
                          ))}
                        </div>
                      )}
                    </div>

                    <div className="flex flex-col w-full">
                      <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit">
                        Destination
                      </label>

                      <select className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md">
                        <option value="">Select your destination</option>
                        <option value="">Option1</option>
                        <option value="">Option2</option>
                        <option value="">Option3</option>
                      </select>
                    </div>

                    <div className="flex flex-col w-full">
                      <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit">
                        Season Type
                      </label>

                      <select className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md">
                        <option value="">Select season type</option>
                        <option value="">Option1</option>
                        <option value="">Option2</option>
                        <option value="">Option3</option>
                      </select>
                    </div>

                    <div className="flex flex-col w-full">
                      <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit">
                        Payment Status
                      </label>

                      <select className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md">
                        <option value="">Select payment status</option>
                        <option value="">Option1</option>
                        <option value="">Option2</option>
                        <option value="">Option3</option>
                      </select>
                    </div>

                    <div className="flex flex-col w-full">
                      <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit">
                        Property
                      </label>

                      <select className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md">
                        <option value="">Select a property</option>
                        <option value="Villa Serenity">Villa Serenity</option>
                        <option value="Villa Arcadia">Villa Arcadia</option>
                        <option value="Villa Mandovi">Villa Mandovi</option>
                        <option value="Villa Sal">Villa Sal</option>
                      </select>
                    </div>

                    <div className="grid grid-cols-2 gap-3 mt-3">
                      <button
                        onClick={() => setIsOpen_popupForm(false)}
                        className="px-6 z-30 py-2 bg-gray-800 rounded-lg text-center text-white relative hover:scale-95 after:-z-20 after:absolute after:h-1 after:w-1 after:bg-gray-700 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700 transition-all duration-700 text-sm"
                      >
                        Cancel
                      </button>

                      <button className="px-6 z-30 py-2 bg-green-900 rounded-lg text-center text-white relative hover:scale-95 after:-z-20 after:absolute after:h-1 after:w-1 after:bg-green-700 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700 transition-all duration-700 text-sm">
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Table */}
        <div>
          {active === "Villas" && (
            <div className="shadow-md rounded-lg mt-5">
              <div className="overflow-x-auto">
                <table className="w-full text-sm text-left rtl:text-right text-gray-500">
                  <thead className="text-xs text-gray-400 uppercase bg-green-50 border-b">
                    <tr>
                      <th className="p-4 w-10">
                        <input
                          type="checkbox"
                          onChange={handleSelectAll_villa}
                          checked={
                            selectedRows_villa.length ===
                              current_property_villa.length &&
                            current_property_villa.length > 0
                          }
                        />
                      </th>
                      <th className="p-4 w-1/10">Top 5 Property</th>
                      <th className="p-4 w-1/10">Villa Rank</th>
                      <th className="p-4 w-1/10">Rating</th>
                      <th className="p-4 w-1/10">Villa Name</th>

                      <th className="p-4 w-1/10">Property Owner</th>
                      <th className="p-4 w-1/10">Location</th>
                      {/* <th className="p-4 w-1/12">Status</th> */}
                      {/* <th className="p-4 w-1/10">Price</th> */}
                      <th className="p-4 w-1/10">Availability</th>
                      <th className="p-4 w-1/10">Score</th>
                      <th className="p-4 w-1/10">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {isLoading ? (
                      <tr>
                        <td colSpan="8" className="text-center py-10">
                          <div className="flex flex-col items-center justify-center gap-3">
                            <div className="h-8 w-8 animate-spin rounded-full border-4 border-gray-200 border-t-gray-800" />
                            <span className="text-sm text-gray-500">
                              Loading properties...
                            </span>
                          </div>
                        </td>
                      </tr>
                    ) : current_property_villa.length === 0 ? (
                      <tr>
                        <td
                          colSpan="8"
                          className="text-center py-6 text-gray-500"
                        >
                          No properties in this category
                        </td>
                      </tr>
                    ) : (
                      current_property_villa.map((villa, index) => (
                        <tr
                          key={index}
                          className="bg-white even:bg-gray-50 border-b border-gray-200 hover:bg-gray-100 text-gray-800"
                        >
                          <td className="px-4 py-3">
                            <input
                              type="checkbox"
                              onChange={() =>
                                handleRowCheckboxChange_villa(villa.order)
                              }
                              checked={selectedRows_villa.includes(villa.order)}
                            />
                          </td>

                          {/* Global Top 5 Property */}
                          <td className="px-4 py-3">
                            <div className="flex items-center gap-2">
                              {/* <label className="relative inline-flex items-center cursor-pointer scale-90">
                                <input
                                  type="checkbox"
                                  className="sr-only peer"
                                  checked={villa.topFiveEnabled}
                                  onChange={() =>
                                    handleToggle_topFive_villa(villa.order)
                                  }
                                />
                                <div className="w-8 h-3 bg-gray-300 peer-focus:outline-none peer-focus:ring-1 peer-focus:ring-blue-800 rounded-full peer peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[-5px] after:left-[-4px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                              </label>

                              {villa.topFiveEnabled && (
                                <select
                                  className="w-20 text-xs border border-gray-400 rounded px-1 py-0.5 focus:outline-none focus:ring-0 focus:border-black"
                                  value={villa.topFiveValue}
                                  onChange={(e) =>
                                    handleDropdownChange_topFive_villa(
                                      villa.order,
                                      e.target.value
                                    )
                                  }
                                >
                                  <option value="">Rank</option>
                                  {[
                                    ...new Set([
                                      villa.topFiveValue,
                                      ...availableRanks,
                                    ]), // union of current rank + available ranks
                                  ]
                                    .filter(Boolean) // remove empty/null
                                    .sort((a, b) => a - b) // sort numerically
                                    .map((val) => (
                                      <option key={val} value={val}>
                                        {val}
                                      </option>
                                    ))}
                                </select>
                              )} */}
                              <RankToggle
                                enabled={villa.topFiveEnabled}
                                value={villa.topFiveValue}
                                onToggle={() =>
                                  handleToggle_topFive_villa(villa.order)
                                }
                                onChange={(val) =>
                                  handleDropdownChange_topFive_villa(
                                    villa.order,
                                    val,
                                  )
                                }
                                availableRanks={availableRanks}
                              />
                            </div>
                          </td>

                          {/* Top within Property */}
                          <td className="px-4 py-3">
                            <div className="flex flex-col items-start gap-2 group">
                              {/* Toggle */}
                              <button
                                type="button"
                                onClick={() =>
                                  handleToggle_topProperty_villa(villa.order)
                                }
                                className={`relative inline-flex h-7 w-[72px] items-center rounded-full transition-colors ${
                                  villa.topPropertyEnabled
                                    ? "bg-green-500"
                                    : "bg-gray-300"
                                }`}
                              >
                                {villa.topPropertyEnabled ? (
                                  <span className="absolute left-2 text-[10px] font-medium text-white">
                                    {villa.topPropertyValue
                                      ? `Rank: ${villa.topPropertyValue}`
                                      : "On"}
                                  </span>
                                ) : (
                                  <span className="absolute right-2 text-[10px] font-medium text-white">
                                    Off
                                  </span>
                                )}
                                <span
                                  className={`inline-block h-5 w-5 transform rounded-full bg-white transition-transform ${
                                    villa.topPropertyEnabled
                                      ? "translate-x-12"
                                      : "translate-x-1"
                                  }`}
                                />
                              </button>

                              {/* Dropdown (only visible when toggle is ON + parent hovered) */}
                              {villa.topPropertyEnabled && (
                                <select
                                  className="w-20 text-xs border border-gray-400 rounded px-1 py-0.5 focus:outline-none focus:ring-1 focus:ring-green-500 hidden group-hover:block"
                                  value={villa.topPropertyValue}
                                  onChange={(e) =>
                                    handleDropdownChange_topProperty_villa(
                                      villa.order,
                                      e.target.value,
                                    )
                                  }
                                >
                                  <option value="">Select Rank</option>

                                  {/* Show current rank if property already has one */}
                                  {villa.topPropertyValue &&
                                    !availableVillaRanks.includes(
                                      Number(villa.topPropertyValue),
                                    ) && (
                                      <option value={villa.topPropertyValue}>
                                        {villa.topPropertyValue}
                                      </option>
                                    )}

                                  {/* Show only available ranks */}
                                  {availableVillaRanks.map((val) => (
                                    <option key={val} value={val}>
                                      {val}
                                    </option>
                                  ))}
                                </select>
                              )}
                            </div>
                          </td>
                          <td className="px-4 py-3">
                            <StarRating
                              rating={villa.rating}
                              onRate={(val) =>
                                confirmRatingChange(
                                  villa.order,
                                  "villa",
                                  val,
                                  villa.customer,
                                )
                              }
                            />
                          </td>
                          <td
                            className="px-4 py-3"
                            data-full-content={villa.customer}
                          >
                            <Tooltip title={villa.customer} placement="left">
                              {villa.customer}
                            </Tooltip>
                          </td>

                          <td className="px-4 py-3">
                            <Tooltip
                              title={villa.propertyowner || "N/A"}
                              placement="left"
                            >
                              {villa.propertyowner || "N/A"}
                            </Tooltip>
                          </td>
                          <td className="px-4 py-3">
                            <Tooltip
                              title={villa.location || "N/A"}
                              placement="left"
                            >
                              {villa.location || "N/A"}
                            </Tooltip>
                          </td>

                          {/* <td className="px-4 py-3">
                            <div className="flex justify-between items-center">
                              <button
                                className={`w-20 px-1 py-1 rounded-lg text-xs scale-90 cursor-default ${
                                  statusColors[villa.status]
                                }`}
                              >
                                {villa.status}
                              </button>
                            </div>
                          </td> */}

                          {/* Online offline toggle here */}
                          <td className="px-4 py-3">
                            <Tooltip
                              content={
                                villa.availability
                                  ? "Click to Disable"
                                  : "Click to Make Live"
                              }
                              placement="left"
                            >
                              <button
                                onClick={() => handleAvailabilityToggle(villa)}
                                className={`inline-flex items-center gap-2 rounded-full border px-3 py-1 transition-all duration-300 hover:scale-105 ${
                                  villa.availability
                                    ? "border-emerald-200 bg-emerald-50 hover:bg-emerald-100"
                                    : "border-gray-200 bg-gray-100 hover:bg-gray-200"
                                }`}
                              >
                                <span
                                  className={`h-2 w-2 rounded-full ${
                                    villa.availability
                                      ? "bg-emerald-500 animate-pulse"
                                      : "bg-gray-400"
                                  }`}
                                ></span>

                                <span
                                  className={`text-xs font-semibold ${
                                    villa.availability
                                      ? "text-emerald-700"
                                      : "text-gray-600"
                                  }`}
                                >
                                  {villa.availability ? "Live" : "Disabled"}
                                </span>
                              </button>
                            </Tooltip>
                          </td>
                          {/* <td className="px-4 py-3">
                            <Tooltip title={villa.payment} placement="left">
                              {villa.payment}
                            </Tooltip>
                          </td> */}
                          <td className="px-4 py-3 text-left">
                            <ProgressBar
                              value={villaProgress[villa.order] ?? 0}
                            />
                          </td>

                          <td>
                            <div className="grid grid-cols-2 gap-y-1 my-2">
                              <Tooltip title="View Property" placement="top">
                                <button
                                  className="pl-5 py-1 text-gray-400 hover:text-sky-500 hover:scale-125 transition-all"
                                  onClick={() => {
                                    sessionStorage.setItem(
                                      "villaPage",
                                      currentPage_villa,
                                    );
                                    navigate("/EditPropertyDetailElementor", {
                                      state: {
                                        propertyid: villa.order,
                                        mode: "view",
                                      },
                                    });
                                  }}
                                >
                                  <FaEye
                                    size={22}
                                    className="border border-sky-300 rounded-full p-0.5"
                                  />
                                </button>
                              </Tooltip>

                              <Tooltip title="Edit Property" placement="top">
                                <button
                                  className="pl-1 py-1 text-gray-400 hover:text-yellow-300 hover:scale-125 transition-all"
                                  // onClick={() =>
                                  //   navigate("/EditPropertyElementor", {
                                  //     state: { propertyid: villa.order },
                                  //   })
                                  // }
                                  onClick={() => {
                                    sessionStorage.setItem(
                                      "villaPage",
                                      currentPage_villa,
                                    ); // ← change here
                                    navigate("/EditPropertyDetailElementor", {
                                      state: { propertyid: villa.order },
                                    });
                                  }}
                                >
                                  <RiFileEditFill
                                    size={22}
                                    className="border border-yellow-300 rounded-full p-0.5"
                                  />
                                </button>
                              </Tooltip>
                              <Tooltip title="Quick Brochure" placement="top">
                                <button
                                  onClick={() =>
                                    navigate(`/QuickBrochure/${villa.order}`)
                                  }
                                  // onClick={() =>
                                  //   window.open("/QuickBrochure", "_blank")
                                  // }
                                  className="pl-5 py-1 text-gray-400 hover:text-purple-500 hover:scale-125 transition-all mail-button"
                                >
                                  <FaFileArrowDown
                                    size={22}
                                    className="border border-purple-300 rounded-full p-[3px]"
                                  />
                                </button>
                              </Tooltip>
                              <Tooltip title="Delete Property" placement="top">
                                <button
                                  onClick={() =>
                                    handleDeleteProperty(villa.order)
                                  }
                                  className="pl-1 py-1 text-gray-400 hover:text-red-500 hover:scale-125 transition-all"
                                >
                                  <MdDelete
                                    size={22}
                                    className="border border-red-300 rounded-full p-0.5"
                                  />
                                </button>
                              </Tooltip>
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
              {/*  Pagination footer villa */}
              <nav
                className="flex items-center flex-column flex-wrap md:flex-row justify-between rounded-b-lg px-2 py-1 bg-[#f7f7f7]"
                aria-label="Table navigation"
              >
                <span className="text-xs font-normal text-gray-500 mb-4 md:mb-0 block w-full md:inline md:w-auto">
                  Showing{" "}
                  <span className="font-semibold text-gray-700">
                    {indexOfFirstTable_villa + 1}-
                    {Math.min(
                      indexOfLastTable_villa,
                      filtered_property_villa.length,
                    )}
                  </span>{" "}
                  of{" "}
                  <span className="font-semibold text-gray-700">
                    {filtered_property_villa.length}
                  </span>
                </span>

                <ul className="inline-flex -space-x-px rtl:space-x-reverse text-xs h-8">
                  <li>
                    <button
                      onClick={handlePrevPage_villa}
                      disabled={currentPage_villa === 1}
                      className="flex items-center justify-center px-1 h-8 ms-0 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 rounded-s-lg hover:bg-gray-100 hover:text-gray-700"
                    >
                      <MdKeyboardDoubleArrowLeft />
                    </button>
                  </li>

                  {generatePageNumbers_villa().map((page, index) =>
                    page === "..." ? (
                      <li
                        key={index}
                        className="px-1 h-8 flex items-center justify-center text-gray-500 bg-[#f7f7f7] border-gray-300"
                      >
                        <span>...</span>
                      </li>
                    ) : (
                      <li key={index}>
                        <button
                          onClick={() => handlePageChange_villa(page)}
                          className={`flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 hover:bg-gray-100 hover:text-gray-700 ${
                            currentPage_villa === page
                              ? "text-green-500 underline underline-offset-2"
                              : ""
                          }`}
                        >
                          {page}
                        </button>
                      </li>
                    ),
                  )}

                  <li>
                    <button
                      onClick={handleNextPage_villa}
                      disabled={currentPage_villa === totalPages_villa}
                      className="flex items-center justify-center px-1 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 rounded-e-lg hover:bg-gray-100 hover:text-gray-700"
                    >
                      <MdKeyboardDoubleArrowRight />
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          )}

          {active === "Hotels" && (
            <div className="shadow-md rounded-lg mt-5">
              <div className="overflow-x-auto">
                <table className="w-full text-sm text-left rtl:text-right text-gray-500">
                  <thead className="text-xs text-gray-400 uppercase bg-green-50 border-b">
                    <tr>
                      <th className="p-4 w-10">
                        <input
                          type="checkbox"
                          onChange={handleSelectAll_hotel}
                          checked={
                            selectedRows_hotel.length ===
                              current_property_hotel.length &&
                            current_property_hotel.length > 0
                          }
                        />
                      </th>
                      <th className="p-4 w-1/10">Top 5 Property</th>
                      <th className="p-4 w-1/10">Hotel Rank</th>
                      <th className="p-4 w-1/10">Rating</th>
                      <th className="p-4 w-1/10">Hotel Name</th>
                      <th className="p-4 w-1/10">Property Owner</th>
                      <th className="p-4 w-1/10">Location</th>
                      {/* <th className="p-4 w-1/12">Status</th> */}
                      {/* <th className="p-4 w-1/10">Price</th> */}
                      <th className="p-4 w-1/10">Availability</th>
                      <th className="p-4 w-1/10">Score</th>
                      <th className="p-4 w-1/10">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {isLoading ? (
                      <tr>
                        <td colSpan="8" className="text-center py-10">
                          <div className="flex flex-col items-center justify-center gap-3">
                            <div className="h-8 w-8 animate-spin rounded-full border-4 border-gray-200 border-t-gray-800" />
                            <span className="text-sm text-gray-500">
                              Loading properties...
                            </span>
                          </div>
                        </td>
                      </tr>
                    ) : current_property_hotel.length === 0 ? (
                      <tr>
                        <td
                          colSpan="8"
                          className="text-center py-6 text-gray-500"
                        >
                          No properties in this category
                        </td>
                      </tr>
                    ) : (
                      current_property_hotel.map((hotel, index) => (
                        <tr
                          key={index}
                          className="bg-white even:bg-gray-50 border-b border-gray-200 hover:bg-gray-100 text-gray-800"
                        >
                          <td className="px-4 py-3">
                            <input
                              type="checkbox"
                              onChange={() =>
                                handleRowCheckboxChange_hotel(hotel.order)
                              }
                              checked={selectedRows_hotel.includes(hotel.order)}
                            />
                          </td>
                          {/* Global Top 5 Property */}
                          <td className="px-4 py-3">
                            {/* <label className="relative inline-flex items-center cursor-pointer scale-90">
                              <input
                                type="checkbox"
                                className="sr-only peer"
                                checked={hotel.topFiveEnabled}
                                onChange={() =>
                                  handleToggle_topFive_hotel(hotel.order)
                                }
                              />
                              <div className="w-8 h-3 bg-gray-300 rounded-full peer peer-checked:bg-blue-600"></div>
                            </label>

                            {hotel.topFiveEnabled && (
                              <select
                                className="w-20 text-xs border rounded px-1 py-0.5"
                                value={hotel.topFiveValue}
                                onChange={(e) =>
                                  handleDropdownChange_topFive_hotel(
                                    hotel.order,
                                    e.target.value
                                  )
                                }
                              >
                                  <option value="">Rank</option>
    {[...new Set([hotel.topFiveValue, ...availableRanks])]
      .filter(Boolean)
      .sort((a, b) => a - b)
      .map((val) => (
        <option key={val} value={val}>
          {val}
        </option>
      ))}
                              </select>
                            )} */}
                            <RankToggle
                              enabled={hotel.topFiveEnabled}
                              value={hotel.topFiveValue}
                              onToggle={() =>
                                handleToggle_topFive_hotel(hotel.order)
                              }
                              onChange={(val) =>
                                handleDropdownChange_topFive_hotel(
                                  hotel.order,
                                  val,
                                )
                              }
                              availableRanks={availableRanks}
                            />
                          </td>
                          {/* Hotel Rank */}
                          <td className="px-4 py-3">
                            <div className="flex flex-col items-start gap-2 group">
                              {/* Toggle */}
                              <button
                                type="button"
                                onClick={() =>
                                  handleToggle_topProperty_hotel(hotel.order)
                                }
                                className={`relative inline-flex h-7 w-[72px] items-center rounded-full transition-colors ${
                                  hotel.topPropertyEnabled
                                    ? "bg-green-500"
                                    : "bg-gray-300"
                                }`}
                              >
                                {hotel.topPropertyEnabled ? (
                                  <span className="absolute left-2 text-[10px] font-medium text-white">
                                    {hotel.topPropertyValue
                                      ? `Rank: ${hotel.topPropertyValue}`
                                      : "On"}
                                  </span>
                                ) : (
                                  <span className="absolute right-2 text-[10px] font-medium text-white">
                                    Off
                                  </span>
                                )}
                                <span
                                  className={`inline-block h-5 w-5 transform rounded-full bg-white transition-transform ${
                                    hotel.topPropertyEnabled
                                      ? "translate-x-12"
                                      : "translate-x-1"
                                  }`}
                                />
                              </button>

                              {/* Dropdown (only visible when toggle is ON + hovered) */}
                              {hotel.topPropertyEnabled && (
                                <select
                                  className="w-20 text-xs border border-gray-400 rounded px-1 py-0.5 focus:outline-none focus:ring-1 focus:ring-green-500 hidden group-hover:block"
                                  value={hotel.topPropertyValue}
                                  onChange={(e) =>
                                    handleDropdownChange_topProperty_hotel(
                                      hotel.order,
                                      e.target.value,
                                    )
                                  }
                                >
                                  <option value="">Select Rank</option>

                                  {/* Keep current rank visible */}
                                  {hotel.topPropertyValue &&
                                    !availableHotelRanks.includes(
                                      Number(hotel.topPropertyValue),
                                    ) && (
                                      <option value={hotel.topPropertyValue}>
                                        {hotel.topPropertyValue}
                                      </option>
                                    )}

                                  {/* Show only available ranks */}
                                  {availableHotelRanks.map((val) => (
                                    <option key={val} value={val}>
                                      {val}
                                    </option>
                                  ))}
                                </select>
                              )}
                            </div>
                          </td>
                          <td className="px-4 py-3">
                            <StarRating
                              rating={hotel.rating}
                              onRate={(val) =>
                                confirmRatingChange(
                                  hotel.order,
                                  "hotel",
                                  val,
                                  hotel.customer,
                                )
                              }
                            />
                          </td>
                          <td
                            className="px-4 py-3"
                            data-full-content={hotel.customer}
                          >
                            <Tooltip title={hotel.customer} placement="left">
                              {hotel.customer}
                            </Tooltip>
                          </td>
                          <td className="px-4 py-3">
                            <Tooltip
                              title={hotel.propertyowner || "N/A"}
                              placement="left"
                            >
                              {hotel.propertyowner || "N/A"}
                            </Tooltip>
                          </td>
                          <td className="px-4 py-3">
                            <Tooltip
                              title={hotel.location || "N/A"}
                              placement="left"
                            >
                              {hotel.location || "N/A"}
                            </Tooltip>
                          </td>

                          {/* <td className="px-4 py-3">
                            <div className="flex justify-between items-center">
                              <button
                                className={`w-20 px-1 py-1 rounded-lg text-xs scale-90 cursor-default ${
                                  statusColors[hotel.status]
                                }`}
                              >
                                {hotel.status}
                              </button>
                            </div>
                          </td> */}
                          <td className="px-4 py-3">
                            <Tooltip
                              content={
                                hotel.availability
                                  ? "Click to Disable"
                                  : "Click to Make Live"
                              }
                              placement="left"
                            >
                              <button
                                onClick={() => handleAvailabilityToggle(hotel)}
                                className={`inline-flex items-center gap-2 rounded-full border px-3 py-1 transition-all duration-300 hover:scale-105 ${
                                  hotel.availability
                                    ? "border-emerald-200 bg-emerald-50 hover:bg-emerald-100"
                                    : "border-gray-200 bg-gray-100 hover:bg-gray-200"
                                }`}
                              >
                                <span
                                  className={`h-2 w-2 rounded-full ${
                                    hotel.availability
                                      ? "bg-emerald-500 animate-pulse"
                                      : "bg-gray-400"
                                  }`}
                                ></span>
                                <span
                                  className={`text-xs font-semibold ${
                                    hotel.availability
                                      ? "text-emerald-700"
                                      : "text-gray-600"
                                  }`}
                                >
                                  {hotel.availability ? "Live" : "Disabled"}
                                </span>
                              </button>
                            </Tooltip>
                          </td>
                          {/* <td className="px-4 py-3">
                            <Tooltip title={hotel.payment} placement="left">
                              {hotel.payment}
                            </Tooltip>
                          </td> */}
                          <td className="px-4 py-3 text-left">
                            <ProgressBar
                              value={hotelProgress[hotel.order] ?? 0}
                            />
                          </td>
                          <td>
                            <div className="flex">
                              <Tooltip title="View Hotel" placement="top">
                                <button
                                  className="px-2 py-1 text-gray-400 hover:text-black hover:dark:text-white hover:scale-125 transition-all duration-300"
                                  // onClick={() =>
                                  //   navigate("/EditPropertyElementor")
                                  // }
                                  onClick={() =>
                                    navigate("/EditPropertyDetailElementor", {
                                      state: { propertyid: hotel.order },
                                    })
                                  }
                                >
                                  <FaEye size={15} />
                                </button>
                              </Tooltip>
                              <Tooltip title="Edit Hotel" placement="top">
                                <button
                                  className="px-2 py-1 text-gray-400 hover:text-black hover:dark:text-white hover:scale-125 transition-all duration-300"
                                  // onClick={() =>
                                  //   navigate("/EditPropertyElementor")
                                  // }
                                  // onClick={() =>
                                  //   navigate("/EditPropertyElementor", {
                                  //     state: { propertyid: hotel.order },
                                  //   })
                                  // }
                                  onClick={() => {
                                    if (active === "Hotels") {
                                      navigate("/EditHotelElementor", {
                                        state: { propertyid: hotel.order },
                                      });
                                    } else {
                                      navigate("/EditPropertyDetailElementor", {
                                        state: { propertyid: hotel.order },
                                      });
                                    }
                                  }}
                                >
                                  <FaEdit size={14} />
                                </button>
                              </Tooltip>
                              <Tooltip title="Delete Hotel" placement="top">
                                <button
                                  onClick={() =>
                                    handleDeleteProperty(hotel.order)
                                  }
                                  className="px-2 py-1 text-gray-400 hover:text-black hover:dark:text-white hover:scale-125 transition-all duration-300"
                                >
                                  <MdDelete size={15} />
                                </button>
                              </Tooltip>
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
              {/*  Pagination footer for Hotels */}
              <nav
                className="flex items-center flex-column flex-wrap md:flex-row justify-between rounded-b-lg px-2 py-1 bg-[#f7f7f7]"
                aria-label="Table navigation"
              >
                <span className="text-xs font-normal text-gray-500 mb-4 md:mb-0 block w-full md:inline md:w-auto">
                  Showing{" "}
                  <span className="font-semibold text-gray-700">
                    {indexOfFirstTable_hotel + 1}-
                    {Math.min(
                      indexOfLastTable_hotel,
                      filtered_property_hotel.length,
                    )}
                  </span>{" "}
                  of{" "}
                  <span className="font-semibold text-gray-700">
                    {filtered_property_hotel.length}
                  </span>
                </span>

                <ul className="inline-flex -space-x-px rtl:space-x-reverse text-xs h-8">
                  <li>
                    <button
                      onClick={handlePrevPage_hotel}
                      disabled={currentPage_hotel === 1}
                      className="flex items-center justify-center px-1 h-8 ms-0 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 rounded-s-lg hover:bg-gray-100 hover:text-gray-700"
                    >
                      <MdKeyboardDoubleArrowLeft />
                    </button>
                  </li>

                  {generatePageNumbers_hotel().map((page, index) =>
                    page === "..." ? (
                      <li
                        key={index}
                        className="px-1 h-8 flex items-center justify-center text-gray-500 bg-[#f7f7f7] border-gray-300"
                      >
                        <span>...</span>
                      </li>
                    ) : (
                      <li key={index}>
                        <button
                          onClick={() => handlePageChange_hotel(page)}
                          className={`flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 hover:bg-gray-100 hover:text-gray-700 ${
                            currentPage_hotel === page
                              ? "text-green-500 underline underline-offset-2"
                              : ""
                          }`}
                        >
                          {page}
                        </button>
                      </li>
                    ),
                  )}

                  <li>
                    <button
                      onClick={handleNextPage_hotel}
                      disabled={currentPage_hotel === totalPages_hotel}
                      className="flex items-center justify-center px-1 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 rounded-e-lg hover:bg-gray-100 hover:text-gray-700"
                    >
                      <MdKeyboardDoubleArrowRight />
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          )}

          {active === "Resorts" && (
            <div className="shadow-md rounded-lg mt-5">
              <div className="overflow-x-auto">
                <table className="w-full text-sm text-left rtl:text-right text-gray-500">
                  <thead className="text-xs text-gray-400 uppercase bg-green-50 border-b">
                    <tr>
                      <th className="p-4 w-10">
                        <input
                          type="checkbox"
                          onChange={handleSelectAll_resort}
                          checked={
                            selectedRows_resort.length ===
                              current_property_resort.length &&
                            current_property_resort.length > 0
                          }
                        />
                      </th>
                      <th className="p-4 w-1/10">Top 5 Property</th>
                      <th className="p-4 w-1/10">Resort Rank</th>

                      <th className="p-4 w-1/10">Resort Name</th>
                      <th className="p-4 w-1/10">Property Owner</th>
                      <th className="p-4 w-1/10">Location</th>
                      <th className="p-4 w-1/12">Status</th>
                      <th className="p-4 w-1/10">Price</th>
                      <th className="p-4 w-1/10">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {current_property_resort.length === 0 ? (
                      <tr>
                        <td
                          colSpan="8"
                          className="text-center py-6 text-gray-500"
                        >
                          No properties in this category
                        </td>
                      </tr>
                    ) : (
                      current_property_resort.map((resort, index) => (
                        <tr
                          key={index}
                          className="bg-white even:bg-gray-50 border-b border-gray-200 hover:bg-gray-100 text-gray-800"
                        >
                          <td className="px-4 py-3">
                            <input
                              type="checkbox"
                              onChange={() =>
                                handleRowCheckboxChange_resort(resort.order)
                              }
                              checked={selectedRows_resort.includes(
                                resort.order,
                              )}
                            />
                          </td>

                          {/* Global Top 5 Property */}
                          <td className="px-4 py-3">
                            {/* <label className="relative inline-flex items-center cursor-pointer scale-90">
                              <input
                                type="checkbox"
                                className="sr-only peer"
                                checked={resort.topFiveEnabled}
                                onChange={() =>
                                  handleToggle_topFive_resort(resort.order)
                                }
                              />
                              <div className="w-8 h-3 bg-gray-300 rounded-full peer peer-checked:bg-blue-600"></div>
                            </label>

                            {resort.topFiveEnabled && (
                              <select
                                className="w-20 text-xs border rounded px-1 py-0.5"
                                value={resort.topFiveValue}
                                onChange={(e) =>
                                  handleDropdownChange_topFive_resort(
                                    resort.order,
                                    e.target.value
                                  )
                                }
                              >
                                <option value="">Rank</option>
    {[...new Set([resort.topFiveValue, ...availableRanks])]
      .filter(Boolean)
      .sort((a, b) => a - b)
      .map((val) => (
        <option key={val} value={val}>
          {val}
        </option>
      ))}
                              </select>
                            )} */}
                            <RankToggle
                              enabled={resort.topFiveEnabled}
                              value={resort.topFiveValue}
                              onToggle={() =>
                                handleToggle_topFive_resort(resort.order)
                              }
                              onChange={(val) =>
                                handleDropdownChange_topFive_resort(
                                  resort.order,
                                  val,
                                )
                              }
                              availableRanks={availableRanks}
                            />
                          </td>
                          {/* Resort Rank */}
                          <td className="px-4 py-3">
                            <div className="flex flex-col items-start gap-2 group">
                              {/* Toggle */}
                              <button
                                type="button"
                                onClick={() =>
                                  handleToggle_topProperty_resort(resort.order)
                                }
                                className={`relative inline-flex h-7 w-[72px] items-center rounded-full transition-colors ${
                                  resort.topPropertyEnabled
                                    ? "bg-green-500"
                                    : "bg-gray-300"
                                }`}
                              >
                                {resort.topPropertyEnabled ? (
                                  <span className="absolute left-2 text-[10px] font-medium text-white">
                                    {resort.topPropertyValue
                                      ? `Rank: ${resort.topPropertyValue}`
                                      : "On"}
                                  </span>
                                ) : (
                                  <span className="absolute right-2 text-[10px] font-medium text-white">
                                    Off
                                  </span>
                                )}
                                <span
                                  className={`inline-block h-5 w-5 transform rounded-full bg-white transition-transform ${
                                    resort.topPropertyEnabled
                                      ? "translate-x-12"
                                      : "translate-x-1"
                                  }`}
                                />
                              </button>

                              {/* Dropdown (only visible when toggle is ON + hovered) */}
                              {resort.topPropertyEnabled && (
                                <select
                                  className="w-20 text-xs border border-gray-400 rounded px-1 py-0.5 focus:outline-none focus:ring-1 focus:ring-green-500 hidden group-hover:block"
                                  value={resort.topPropertyValue}
                                  onChange={(e) =>
                                    handleDropdownChange_topProperty_resort(
                                      resort.order,
                                      e.target.value,
                                    )
                                  }
                                >
                                  <option value="">Select Rank</option>

                                  {/* Keep current rank visible */}
                                  {resort.topPropertyValue &&
                                    !availableResortRanks.includes(
                                      Number(resort.topPropertyValue),
                                    ) && (
                                      <option value={resort.topPropertyValue}>
                                        {resort.topPropertyValue}
                                      </option>
                                    )}

                                  {/* Show only available ranks */}
                                  {availableResortRanks.map((val) => (
                                    <option key={val} value={val}>
                                      {val}
                                    </option>
                                  ))}
                                </select>
                              )}
                            </div>
                          </td>

                          <td
                            className="px-4 py-3"
                            data-full-content={resort.customer}
                          >
                            <Tooltip title={resort.customer} placement="left">
                              {resort.customer}
                            </Tooltip>
                          </td>
                          <td className="px-4 py-3">
                            <Tooltip
                              title={resort.propertyowner || "N/A"}
                              placement="left"
                            >
                              {resort.propertyowner || "N/A"}
                            </Tooltip>
                          </td>
                          <td className="px-4 py-3">
                            <Tooltip
                              title={resort.location || "N/A"}
                              placement="left"
                            >
                              {resort.location || "N/A"}
                            </Tooltip>
                          </td>

                          <td className="px-4 py-3">
                            <div className="flex justify-between items-center">
                              <button
                                className={`w-20 px-1 py-1 rounded-lg text-xs scale-90 cursor-default ${
                                  statusColors[resort.status]
                                }`}
                              >
                                {resort.status}
                              </button>
                            </div>
                          </td>

                          <td className="px-4 py-3">
                            <Tooltip title={resort.payment} placement="left">
                              {resort.payment}
                            </Tooltip>
                          </td>

                          <td>
                            <div className="flex ">
                              <button
                                className="px-2 py-1 text-gray-400 hover:text-black hover:dark:text-white hover:scale-125 transition-all duration-300"
                                // onClick={() =>
                                //   navigate("/EditPropertyElementor")
                                // }
                                onClick={() =>
                                  navigate("/EditPropertyDetailElementor", {
                                    state: { propertyid: resort.order },
                                  })
                                }
                              >
                                <FaEye size={15} />
                              </button>

                              <button
                                className="px-2 py-1 text-gray-400 hover:text-black hover:dark:text-white hover:scale-125 transition-all duration-300"
                                // onClick={() =>
                                //   navigate("/EditPropertyElementor")
                                // }
                                onClick={() =>
                                  navigate("/EditPropertyDetailElementor", {
                                    state: { propertyid: resort.order },
                                  })
                                }
                              >
                                <FaEdit size={14} />
                              </button>
                              <button
                                onClick={() =>
                                  handleDeleteProperty(resort.order)
                                }
                                className="px-2 py-1 text-gray-400 hover:text-black hover:dark:text-white hover:scale-125 transition-all duration-300"
                              >
                                <MdDelete size={15} />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
              {/*  Pagination footer for Resorts */}
              <nav
                className="flex items-center flex-column flex-wrap md:flex-row justify-between rounded-b-lg px-2 py-1 bg-[#f7f7f7]"
                aria-label="Table navigation"
              >
                <span className="text-xs font-normal text-gray-500 mb-4 md:mb-0 block w-full md:inline md:w-auto">
                  Showing{" "}
                  <span className="font-semibold text-gray-700">
                    {indexOfFirstTable_resort + 1}-
                    {Math.min(
                      indexOfLastTable_resort,
                      filtered_property_resort.length,
                    )}
                  </span>{" "}
                  of{" "}
                  <span className="font-semibold text-gray-700">
                    {filtered_property_resort.length}
                  </span>
                </span>

                <ul className="inline-flex -space-x-px rtl:space-x-reverse text-xs h-8">
                  <li>
                    <button
                      onClick={handlePrevPage_resort}
                      disabled={currentPage_resort === 1}
                      className="flex items-center justify-center px-1 h-8 ms-0 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 rounded-s-lg hover:bg-gray-100 hover:text-gray-700"
                    >
                      <MdKeyboardDoubleArrowLeft />
                    </button>
                  </li>

                  {generatePageNumbers_resort().map((page, index) =>
                    page === "..." ? (
                      <li
                        key={index}
                        className="px-1 h-8 flex items-center justify-center text-gray-500 bg-[#f7f7f7] border-gray-300"
                      >
                        <span>...</span>
                      </li>
                    ) : (
                      <li key={index}>
                        <button
                          onClick={() => handlePageChange_resort(page)}
                          className={`flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 hover:bg-gray-100 hover:text-gray-700 ${
                            currentPage_resort === page
                              ? "text-green-500 underline underline-offset-2"
                              : ""
                          }`}
                        >
                          {page}
                        </button>
                      </li>
                    ),
                  )}

                  <li>
                    <button
                      onClick={handleNextPage_resort}
                      disabled={currentPage_resort === totalPages_resort}
                      className="flex items-center justify-center px-1 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 rounded-e-lg hover:bg-gray-100 hover:text-gray-700"
                    >
                      <MdKeyboardDoubleArrowRight />
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          )}

          {active === "Apartments" && (
            <div className="shadow-md rounded-lg mt-5">
              <div className="overflow-x-auto">
                <table className="w-full text-sm text-left rtl:text-right text-gray-500">
                  <thead className="text-xs text-gray-400 uppercase bg-green-50 border-b">
                    <tr>
                      <th className="p-4 w-10">
                        <input
                          type="checkbox"
                          onChange={handleSelectAll_apartment}
                          checked={
                            selectedRows_apartment.length ===
                              current_property_apartment.length &&
                            current_property_apartment.length > 0
                          }
                        />
                      </th>
                      <th className="p-4 w-1/10">Top 5 Property</th>
                      <th className="p-4 w-1/10">Apartment Rank</th>
                      <th className="p-4 w-1/10">Apartment Name</th>
                      <th className="p-4 w-1/10">Property Owner</th>
                      <th className="p-4 w-1/10">Location</th>
                      <th className="p-4 w-1/12">Status</th>
                      <th className="p-4 w-1/10">Price</th>
                      <th className="p-4 w-1/10">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {current_property_apartment.length === 0 ? (
                      <tr>
                        <td
                          colSpan="9"
                          className="text-center py-6 text-gray-500"
                        >
                          No properties in this category
                        </td>
                      </tr>
                    ) : (
                      current_property_apartment.map((apartment, index) => (
                        <tr
                          key={index}
                          className="bg-white even:bg-gray-50 border-b border-gray-200 hover:bg-gray-100 text-gray-800"
                        >
                          <td className="px-4 py-3">
                            <input
                              type="checkbox"
                              onChange={() => {
                                if (
                                  selectedRows_apartment.includes(
                                    apartment.order,
                                  )
                                ) {
                                  setSelectedRows_apartment(
                                    selectedRows_apartment.filter(
                                      (id) => id !== apartment.order,
                                    ),
                                  );
                                } else {
                                  setSelectedRows_apartment([
                                    ...selectedRows_apartment,
                                    apartment.order,
                                  ]);
                                }
                              }}
                              checked={selectedRows_apartment.includes(
                                apartment.order,
                              )}
                            />
                          </td>

                          {/* Global Top 5 Property */}
                          <td className="px-4 py-3">
                            <RankToggle
                              enabled={apartment.topFiveEnabled}
                              value={apartment.topFiveValue}
                              onToggle={() =>
                                handleToggle_topFive_apartment(apartment.order)
                              }
                              onChange={(val) =>
                                handleDropdownChange_topFive_apartment(
                                  apartment.order,
                                  val,
                                )
                              }
                              availableRanks={availableRanks}
                            />
                          </td>

                          {/* Apartment Rank */}
                          <td className="px-4 py-3">
                            <div className="flex flex-col items-start gap-2 group">
                              {/* Toggle */}
                              <button
                                type="button"
                                onClick={() =>
                                  handleToggle_topProperty_apartment(
                                    apartment.order,
                                  )
                                }
                                className={`relative inline-flex h-7 w-20 items-center rounded-full transition-colors ${
                                  apartment.topPropertyEnabled
                                    ? "bg-green-500"
                                    : "bg-gray-300"
                                }`}
                              >
                                {apartment.topPropertyEnabled ? (
                                  <span className="absolute left-2 text-[10px] font-medium text-white">
                                    {apartment.topPropertyValue
                                      ? `Rank:${apartment.topPropertyValue}`
                                      : "On"}
                                  </span>
                                ) : (
                                  <span className="absolute right-2 text-[10px] font-medium text-white">
                                    Off
                                  </span>
                                )}
                                <span
                                  className={`inline-block h-5 w-5 transform rounded-full bg-white transition-transform ${
                                    apartment.topPropertyEnabled
                                      ? "translate-x-12"
                                      : "translate-x-0"
                                  }`}
                                />
                              </button>

                              {/* Dropdown (only visible when toggle is ON + hovered) */}
                              {apartment.topPropertyEnabled && (
                                <select
                                  className="w-20 text-xs border border-gray-400 rounded px-1 py-0.5 focus:outline-none focus:ring-1 focus:ring-green-500 hidden group-hover:block"
                                  value={apartment.topPropertyValue}
                                  onChange={(e) =>
                                    handleDropdownChange_topProperty_apartment(
                                      apartment.order,
                                      e.target.value,
                                    )
                                  }
                                >
                                  <option value="">Select Rank</option>

                                  {/* Keep current rank visible */}
                                  {apartment.topPropertyValue &&
                                    !availableApartmentRanks.includes(
                                      Number(apartment.topPropertyValue),
                                    ) && (
                                      <option
                                        value={apartment.topPropertyValue}
                                      >
                                        {apartment.topPropertyValue}
                                      </option>
                                    )}

                                  {/* Show only available ranks */}
                                  {availableApartmentRanks.map((val) => (
                                    <option key={val} value={val}>
                                      {val}
                                    </option>
                                  ))}
                                </select>
                              )}
                            </div>
                          </td>

                          <td
                            className="px-4 py-3"
                            data-full-content={apartment.customer}
                          >
                            <Tooltip
                              title={apartment.customer}
                              placement="left"
                            >
                              {apartment.customer}
                            </Tooltip>
                          </td>
                          <td className="px-4 py-3">
                            <Tooltip
                              title={apartment.propertyowner || "N/A"}
                              placement="left"
                            >
                              {apartment.propertyowner || "N/A"}
                            </Tooltip>
                          </td>
                          <td className="px-4 py-3">
                            <Tooltip
                              title={apartment.location || "N/A"}
                              placement="left"
                            >
                              {apartment.location || "N/A"}
                            </Tooltip>
                          </td>

                          <td className="px-4 py-3">
                            <div className="flex justify-between items-center">
                              <button
                                className={`w-20 px-1 py-1 rounded-lg text-xs scale-90 cursor-default ${
                                  statusColors[apartment.status]
                                }`}
                              >
                                {apartment.status}
                              </button>
                            </div>
                          </td>

                          <td className="px-4 py-3">
                            <Tooltip title={apartment.payment} placement="left">
                              {apartment.payment}
                            </Tooltip>
                          </td>

                          <td>
                            <div className="flex">
                              <button
                                className="px-2 py-1 text-gray-400 hover:text-black hover:dark:text-white hover:scale-125 transition-all duration-300"
                                onClick={() =>
                                  navigate("/EditPropertyDetailElementor", {
                                    state: { propertyid: apartment.order },
                                  })
                                }
                              >
                                <FaEye size={15} />
                              </button>

                              <button
                                className="px-2 py-1 text-gray-400 hover:text-black hover:dark:text-white hover:scale-125 transition-all duration-300"
                                onClick={() =>
                                  navigate("/EditPropertyDetailElementor", {
                                    state: { propertyid: apartment.order },
                                  })
                                }
                              >
                                <FaEdit size={14} />
                              </button>

                              <button
                                onClick={() =>
                                  handleDeleteProperty(apartment.order)
                                }
                                className="px-2 py-1 text-gray-400 hover:text-black hover:dark:text-white hover:scale-125 transition-all duration-300"
                              >
                                <MdDelete size={15} />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
              {/*  Pagination footer for Apartments */}
              <nav
                className="flex items-center flex-column flex-wrap md:flex-row justify-between rounded-b-lg px-2 py-1 bg-[#f7f7f7]"
                aria-label="Table navigation"
              >
                <span className="text-xs font-normal text-gray-500 mb-4 md:mb-0 block w-full md:inline md:w-auto">
                  Showing{" "}
                  <span className="font-semibold text-gray-700">
                    {indexOfFirstTable_apartment + 1}-
                    {Math.min(
                      indexOfLastTable_apartment,
                      filtered_property_apartment.length,
                    )}
                  </span>{" "}
                  of{" "}
                  <span className="font-semibold text-gray-700">
                    {filtered_property_apartment.length}
                  </span>
                </span>

                <ul className="inline-flex -space-x-px rtl:space-x-reverse text-xs h-8">
                  <li>
                    <button
                      onClick={handlePrevPage_apartment}
                      disabled={currentPage_apartment === 1}
                      className="flex items-center justify-center px-1 h-8 ms-0 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 rounded-s-lg hover:bg-gray-100 hover:text-gray-700"
                    >
                      <MdKeyboardDoubleArrowLeft />
                    </button>
                  </li>

                  {generatePageNumbers_apartment().map((page, index) =>
                    page === "..." ? (
                      <li
                        key={index}
                        className="px-1 h-8 flex items-center justify-center text-gray-500 bg-[#f7f7f7] border-gray-300"
                      >
                        <span>...</span>
                      </li>
                    ) : (
                      <li key={index}>
                        <button
                          onClick={() => handlePageChange_apartment(page)}
                          className={`flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 hover:bg-gray-100 hover:text-gray-700 ${
                            currentPage_apartment === page
                              ? "text-green-500 underline underline-offset-2"
                              : ""
                          }`}
                        >
                          {page}
                        </button>
                      </li>
                    ),
                  )}

                  <li>
                    <button
                      onClick={handleNextPage_apartment}
                      disabled={currentPage_apartment === totalPages_apartment}
                      className="flex items-center justify-center px-1 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 rounded-e-lg hover:bg-gray-100 hover:text-gray-700"
                    >
                      <MdKeyboardDoubleArrowRight />
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          )}
        </div>
      </main>
    </div>
  );
};

export default Properties;
